// Generated from the deck names inside the exact preview APKGs.
// Customer-facing names only: no local paths or production metadata are shipped.
window.BOLT_COMPLETE_DECK_HIERARCHIES={
  "Pearson Edexcel International A Level Biology (YBI11; WBI11-WBI16) - BOLT": {
    "root": "Pearson Edexcel International A Level Biology (YBI11; WBI11-WBI16) - BOLT",
    "open": true,
    "papers": [
      {
        "name": "WBI11 Unit 1 Molecules, Diet, Transport and Health",
        "open": false,
        "children": [
          {
            "name": "Topic 1",
            "open": false,
            "children": [
              {
                "name": "01 Water and biological molecules",
                "open": false,
                "children": []
              },
              {
                "name": "02 Circulation and gas transport",
                "open": false,
                "children": []
              },
              {
                "name": "03 Cardiovascular disease",
                "open": false,
                "children": []
              },
              {
                "name": "04 Health evidence, risk and treatment",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "Topic 2",
            "open": false,
            "children": [
              {
                "name": "01 Gas exchange and diffusion",
                "open": false,
                "children": []
              },
              {
                "name": "02 Membranes and transport",
                "open": false,
                "children": []
              },
              {
                "name": "03 Proteins and enzymes",
                "open": false,
                "children": []
              },
              {
                "name": "04 Nucleic acids and protein synthesis",
                "open": false,
                "children": []
              },
              {
                "name": "05 Inheritance and cystic fibrosis",
                "open": false,
                "children": []
              },
              {
                "name": "06 Genetic screening and ethics",
                "open": false,
                "children": []
              }
            ]
          }
        ]
      },
      {
        "name": "WBI12 Unit 2 Cells, Development, Biodiversity and Conservation",
        "open": false,
        "children": [
          {
            "name": "Topic 3",
            "open": false,
            "children": [
              {
                "name": "01 Cell organisation and ultrastructure",
                "open": false,
                "children": []
              },
              {
                "name": "02 Microscopy and measurement",
                "open": false,
                "children": []
              },
              {
                "name": "03 Chromosomes, meiosis and fertilisation",
                "open": false,
                "children": []
              },
              {
                "name": "04 Cell cycle and mitosis",
                "open": false,
                "children": []
              },
              {
                "name": "05 Stem cells and differential expression",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "Topic 4",
            "open": false,
            "children": [
              {
                "name": "01 Plant cells and biological molecules",
                "open": false,
                "children": []
              },
              {
                "name": "02 Plant transport tissues",
                "open": false,
                "children": []
              },
              {
                "name": "03 Antimicrobials and drug testing",
                "open": false,
                "children": []
              },
              {
                "name": "04 Classification and biodiversity",
                "open": false,
                "children": []
              },
              {
                "name": "05 Adaptation, evolution and conservation",
                "open": false,
                "children": []
              }
            ]
          }
        ]
      },
      {
        "name": "WBI14 Unit 4 Energy, Environment, Microbiology and Immunity",
        "open": false,
        "children": [
          {
            "name": "Topic 5",
            "open": false,
            "children": [
              {
                "name": "01 Photosynthesis and chloroplasts",
                "open": false,
                "children": []
              },
              {
                "name": "02 Productivity and energy transfer",
                "open": false,
                "children": []
              },
              {
                "name": "03 Ecology and succession",
                "open": false,
                "children": []
              },
              {
                "name": "04 Climate change",
                "open": false,
                "children": []
              },
              {
                "name": "05 Evolution, speciation and sustainability",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "Topic 6",
            "open": false,
            "children": [
              {
                "name": "01 Microbial culture and growth",
                "open": false,
                "children": []
              },
              {
                "name": "02 Pathogens and infection",
                "open": false,
                "children": []
              },
              {
                "name": "03 Immune responses and immunity",
                "open": false,
                "children": []
              },
              {
                "name": "04 Antibiotics and infection control",
                "open": false,
                "children": []
              },
              {
                "name": "05 Decomposition and DNA technologies",
                "open": false,
                "children": []
              },
              {
                "name": "06 Forensic time of death",
                "open": false,
                "children": []
              }
            ]
          }
        ]
      },
      {
        "name": "WBI15 Unit 5 Respiration, Internal Environment, Coordination and Gene Technology",
        "open": false,
        "children": [
          {
            "name": "Topic 7",
            "open": false,
            "children": [
              {
                "name": "01 Respiration and ATP",
                "open": false,
                "children": []
              },
              {
                "name": "02 Movement and skeletal muscle",
                "open": false,
                "children": []
              },
              {
                "name": "03 Cardiac and ventilation control",
                "open": false,
                "children": []
              },
              {
                "name": "04 Homeostasis and thermoregulation",
                "open": false,
                "children": []
              },
              {
                "name": "05 Kidney, excretion and osmoregulation",
                "open": false,
                "children": []
              },
              {
                "name": "06 Hormonal control of transcription",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "Topic 8",
            "open": false,
            "children": [
              {
                "name": "01 Neurones, impulses and reflexes",
                "open": false,
                "children": []
              },
              {
                "name": "02 Drugs and sensory reception",
                "open": false,
                "children": []
              },
              {
                "name": "03 Plant responses",
                "open": false,
                "children": []
              },
              {
                "name": "04 Animal coordination and brain",
                "open": false,
                "children": []
              },
              {
                "name": "05 Genetic engineering and bioinformatics",
                "open": false,
                "children": []
              }
            ]
          }
        ]
      }
    ],
    "deckCount": 55
  },
  "WJEC GCSE Biology 3400QS": {
    "root": "WJEC GCSE Biology 3400QS",
    "open": true,
    "papers": [
      {
        "name": "01 Cells, Organ Systems and Ecosystems",
        "open": false,
        "children": [
          {
            "name": "01 Cells and movement across cell membranes",
            "open": false,
            "children": []
          },
          {
            "name": "02 Respiration and the respiratory system in humans",
            "open": false,
            "children": []
          },
          {
            "name": "03 Digestion and the digestive system in humans",
            "open": false,
            "children": []
          },
          {
            "name": "04 Circulatory system in humans",
            "open": false,
            "children": []
          },
          {
            "name": "05 Plants and photosynthesis",
            "open": false,
            "children": []
          },
          {
            "name": "06 Ecosystems, nutrient cycles and human impact on the environment",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "02 Variation, Homeostasis and Micro-organisms",
        "open": false,
        "children": [
          {
            "name": "01 Classification and biodiversity",
            "open": false,
            "children": []
          },
          {
            "name": "02 Cell division and stem cells",
            "open": false,
            "children": []
          },
          {
            "name": "03 DNA and inheritance",
            "open": false,
            "children": []
          },
          {
            "name": "04 Variation and evolution",
            "open": false,
            "children": []
          },
          {
            "name": "05 Response and regulation",
            "open": false,
            "children": []
          },
          {
            "name": "06 Role of the kidney in homeostasis",
            "open": false,
            "children": []
          },
          {
            "name": "07 Micro-organisms and their applications",
            "open": false,
            "children": []
          },
          {
            "name": "08 Disease, defence and treatment",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "03 Scientific Enquiry",
        "open": false,
        "children": [
          {
            "name": "01 Developing scientific thinking",
            "open": false,
            "children": []
          },
          {
            "name": "02 Experimental design and safe practical work",
            "open": false,
            "children": []
          },
          {
            "name": "03 Data quality, recording and presentation",
            "open": false,
            "children": []
          },
          {
            "name": "04 Analysis, conclusions and evaluation",
            "open": false,
            "children": []
          }
        ]
      }
    ],
    "deckCount": 22
  },
  "AQA GCSE Physics (8463)": {
    "root": "AQA GCSE Physics (8463)",
    "open": true,
    "papers": [
      {
        "name": "1. Energy",
        "open": false,
        "children": [
          {
            "name": "1.1 Energy Changes in a System, and the Ways Energy is Stored Before and After Such Changes",
            "open": false,
            "children": []
          },
          {
            "name": "1.2 Conservation and Dissipation of Energy",
            "open": false,
            "children": []
          },
          {
            "name": "1.3 National and Global Energy Resources",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "2. Electricity",
        "open": false,
        "children": [
          {
            "name": "2.1 Current, Potential Difference and Resistance",
            "open": false,
            "children": []
          },
          {
            "name": "2.2 Series and Parallel Circuits",
            "open": false,
            "children": []
          },
          {
            "name": "2.3 Domestic Uses and Safety",
            "open": false,
            "children": []
          },
          {
            "name": "2.4 Energy Transfers",
            "open": false,
            "children": []
          },
          {
            "name": "2.5 Static Electricity",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "3. Particle Model of Matter",
        "open": false,
        "children": [
          {
            "name": "3.1 Changes of State and the Particle Model",
            "open": false,
            "children": []
          },
          {
            "name": "3.2 Internal Energy and Energy Transfers",
            "open": false,
            "children": []
          },
          {
            "name": "3.3 Particle Model and Pressure",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "4. Atomic Structure",
        "open": false,
        "children": [
          {
            "name": "4.1 Atoms and Isotopes",
            "open": false,
            "children": []
          },
          {
            "name": "4.2 Atoms and Nuclear Radiation",
            "open": false,
            "children": []
          },
          {
            "name": "4.3 Hazards and Uses of Radioactive Emissions and Background Radiation",
            "open": false,
            "children": []
          },
          {
            "name": "4.4 Nuclear Fission and Nuclear Fusion",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "5. Forces",
        "open": false,
        "children": [
          {
            "name": "5.1 Forces and Their Interactions",
            "open": false,
            "children": []
          },
          {
            "name": "5.2 Work Done and Energy Transfer",
            "open": false,
            "children": []
          },
          {
            "name": "5.3 Forces and Elasticity",
            "open": false,
            "children": []
          },
          {
            "name": "5.4 Moments, Levers and Gears",
            "open": false,
            "children": []
          },
          {
            "name": "5.5 Pressure",
            "open": false,
            "children": []
          },
          {
            "name": "5.6 Motion",
            "open": false,
            "children": []
          },
          {
            "name": "5.7 Forces and Braking",
            "open": false,
            "children": []
          },
          {
            "name": "5.8 Momentum (Triple)",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "6. Waves",
        "open": false,
        "children": [
          {
            "name": "6.1 Waves in Air, Fluids and Solids",
            "open": false,
            "children": []
          },
          {
            "name": "6.2 Electromagnetic Waves",
            "open": false,
            "children": []
          },
          {
            "name": "6.3 Light",
            "open": false,
            "children": []
          },
          {
            "name": "6.4 Black Body Radiation (Triple)",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "7. Magnetism and Electromagnetism",
        "open": false,
        "children": [
          {
            "name": "7.1 Permanent and Induced Magnetism, Magnetic Forces and Fields",
            "open": false,
            "children": []
          },
          {
            "name": "7.2 The Motor Effect",
            "open": false,
            "children": []
          },
          {
            "name": "7.3 Induced Potential, Transformers and the National Grid",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "8. Space Physics",
        "open": false,
        "children": [
          {
            "name": "8.1 Solar System",
            "open": false,
            "children": []
          },
          {
            "name": "8.2 Life History of a Star",
            "open": false,
            "children": []
          },
          {
            "name": "8.3 Orbital Motion",
            "open": false,
            "children": []
          },
          {
            "name": "8.4 Red Shift",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "9. Practical Skills (Required Practicals)",
        "open": false,
        "children": [
          {
            "name": "RP1. Specific Heat Capacity",
            "open": false,
            "children": []
          },
          {
            "name": "RP2. Thermal Insulation",
            "open": false,
            "children": []
          },
          {
            "name": "RP3. Resistance",
            "open": false,
            "children": []
          },
          {
            "name": "RP4. Current–Potential Difference Characteristics",
            "open": false,
            "children": []
          },
          {
            "name": "RP5. Density",
            "open": false,
            "children": []
          },
          {
            "name": "RP6. Force and Extension (Hooke's Law)",
            "open": false,
            "children": []
          },
          {
            "name": "RP7. Acceleration",
            "open": false,
            "children": []
          },
          {
            "name": "RP8. Wave Speed",
            "open": false,
            "children": []
          },
          {
            "name": "RP9. Reflection and Refraction",
            "open": false,
            "children": []
          },
          {
            "name": "RP10. Infrared Radiation",
            "open": false,
            "children": []
          }
        ]
      }
    ],
    "deckCount": 54
  },
  "CAIE A Level Physics (9702)": {
    "root": "CAIE A Level Physics (9702)",
    "open": true,
    "papers": [
      {
        "name": "01 - Topic 1 - Physical Quantities and Units",
        "open": false,
        "children": []
      },
      {
        "name": "02 - Topic 2 - Kinematics",
        "open": false,
        "children": []
      },
      {
        "name": "03 - Topic 3 - Dynamics",
        "open": false,
        "children": []
      },
      {
        "name": "04 - Topic 4 - Forces, Density and Pressure",
        "open": false,
        "children": []
      },
      {
        "name": "05 - Topic 5 - Work, Energy and Power",
        "open": false,
        "children": []
      },
      {
        "name": "06 - Topic 6 - Deformation of Solids",
        "open": false,
        "children": []
      },
      {
        "name": "07 - Topic 7 - Waves",
        "open": false,
        "children": []
      },
      {
        "name": "08 - Topic 8 - Superposition",
        "open": false,
        "children": []
      },
      {
        "name": "09 - Topic 9 - Electricity",
        "open": false,
        "children": []
      },
      {
        "name": "10 - Topic 10 - D.C. Circuits",
        "open": false,
        "children": []
      },
      {
        "name": "11 - Topic 11 - Particle Physics",
        "open": false,
        "children": []
      },
      {
        "name": "12 - Topic 12 - Motion in a Circle",
        "open": false,
        "children": []
      },
      {
        "name": "13 - Topic 13 - Gravitational Fields",
        "open": false,
        "children": []
      },
      {
        "name": "14 - Topic 14 - Temperature",
        "open": false,
        "children": []
      },
      {
        "name": "15 - Topic 15 - Ideal Gases",
        "open": false,
        "children": []
      },
      {
        "name": "16 - Topic 16 - Thermodynamics",
        "open": false,
        "children": []
      },
      {
        "name": "17 - Topic 17 - Oscillations",
        "open": false,
        "children": []
      },
      {
        "name": "18 - Topic 18 - Electric Fields",
        "open": false,
        "children": []
      },
      {
        "name": "19 - Topic 19 - Capacitance",
        "open": false,
        "children": []
      },
      {
        "name": "20 - Topic 20 - Magnetic Fields",
        "open": false,
        "children": []
      },
      {
        "name": "21 - Topic 21 - Alternating Currents",
        "open": false,
        "children": []
      },
      {
        "name": "22 - Topic 22 - Quantum Physics",
        "open": false,
        "children": []
      },
      {
        "name": "23 - Topic 23 - Nuclear Physics",
        "open": false,
        "children": []
      },
      {
        "name": "24 - Topic 24 - Medical Physics",
        "open": false,
        "children": []
      },
      {
        "name": "25 - Topic 25 - Astronomy and Cosmology",
        "open": false,
        "children": []
      },
      {
        "name": "26 - Practical Skills",
        "open": false,
        "children": [
          {
            "name": "01 - Measurement Techniques",
            "open": false,
            "children": []
          },
          {
            "name": "02 - Manipulation, Measurement and Observation",
            "open": false,
            "children": []
          },
          {
            "name": "03 - Presentation of Data and Observations",
            "open": false,
            "children": []
          },
          {
            "name": "04 - Analysis, Conclusions and Evaluation",
            "open": false,
            "children": []
          },
          {
            "name": "05 - Planning",
            "open": false,
            "children": []
          }
        ]
      }
    ],
    "deckCount": 32
  },
  "Cambridge IGCSE Physics (0625)": {
    "root": "Cambridge IGCSE Physics (0625)",
    "open": true,
    "papers": [
      {
        "name": "1 Motion, forces and energy",
        "open": false,
        "children": [
          {
            "name": "1.1 Physical quantities and measurement techniques",
            "open": false,
            "children": []
          },
          {
            "name": "1.2 Motion",
            "open": false,
            "children": []
          },
          {
            "name": "1.3 Mass and weight",
            "open": false,
            "children": []
          },
          {
            "name": "1.4 Density",
            "open": false,
            "children": []
          },
          {
            "name": "1.5 Forces",
            "open": false,
            "children": [
              {
                "name": "1.5.1 Effects of forces",
                "open": false,
                "children": []
              },
              {
                "name": "1.5.2 Turning effect of forces",
                "open": false,
                "children": []
              },
              {
                "name": "1.5.3 Centre of gravity",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "1.6 Momentum",
            "open": false,
            "children": []
          },
          {
            "name": "1.7 Energy, work and power",
            "open": false,
            "children": [
              {
                "name": "1.7.1 Energy",
                "open": false,
                "children": []
              },
              {
                "name": "1.7.2 Work",
                "open": false,
                "children": []
              },
              {
                "name": "1.7.3 Energy resources",
                "open": false,
                "children": []
              },
              {
                "name": "1.7.4 Power",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "1.8 Pressure",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "2 Thermal physics",
        "open": false,
        "children": [
          {
            "name": "2.1 Kinetic particle model of matter",
            "open": false,
            "children": [
              {
                "name": "2.1.1 States of matter",
                "open": false,
                "children": []
              },
              {
                "name": "2.1.2 Particle model",
                "open": false,
                "children": []
              },
              {
                "name": "2.1.3 Gases and the absolute scale of temperature",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "2.2 Thermal properties and temperature",
            "open": false,
            "children": [
              {
                "name": "2.2.1 Thermal expansion of solids, liquids and gases",
                "open": false,
                "children": []
              },
              {
                "name": "2.2.2 Specific heat capacity",
                "open": false,
                "children": []
              },
              {
                "name": "2.2.3 Melting, boiling and evaporation",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "2.3 Transfer of thermal energy",
            "open": false,
            "children": [
              {
                "name": "2.3.1 Conduction",
                "open": false,
                "children": []
              },
              {
                "name": "2.3.2 Convection",
                "open": false,
                "children": []
              },
              {
                "name": "2.3.3 Radiation",
                "open": false,
                "children": []
              },
              {
                "name": "2.3.4 Consequences of thermal energy transfer",
                "open": false,
                "children": []
              }
            ]
          }
        ]
      },
      {
        "name": "3 Waves",
        "open": false,
        "children": [
          {
            "name": "3.1 General properties of waves",
            "open": false,
            "children": []
          },
          {
            "name": "3.2 Light",
            "open": false,
            "children": [
              {
                "name": "3.2.1 Reflection of light",
                "open": false,
                "children": []
              },
              {
                "name": "3.2.2 Refraction of light",
                "open": false,
                "children": []
              },
              {
                "name": "3.2.3 Thin lenses",
                "open": false,
                "children": []
              },
              {
                "name": "3.2.4 Dispersion of light",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "3.3 Electromagnetic spectrum",
            "open": false,
            "children": []
          },
          {
            "name": "3.4 Sound",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "4 Electricity and magnetism",
        "open": false,
        "children": [
          {
            "name": "4.1 Simple phenomena of magnetism",
            "open": false,
            "children": []
          },
          {
            "name": "4.2 Electrical quantities",
            "open": false,
            "children": [
              {
                "name": "4.2.1 Electric charge",
                "open": false,
                "children": []
              },
              {
                "name": "4.2.2 Electric current",
                "open": false,
                "children": []
              },
              {
                "name": "4.2.3 Electromotive force and potential difference",
                "open": false,
                "children": []
              },
              {
                "name": "4.2.4 Resistance",
                "open": false,
                "children": []
              },
              {
                "name": "4.2.5 Electrical energy and electrical power",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "4.3 Electric circuits",
            "open": false,
            "children": [
              {
                "name": "4.3.1 Circuit diagrams and circuit components",
                "open": false,
                "children": []
              },
              {
                "name": "4.3.2 Series and parallel circuits",
                "open": false,
                "children": []
              },
              {
                "name": "4.3.3 Action and use of circuit components",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "4.4 Electrical safety",
            "open": false,
            "children": []
          },
          {
            "name": "4.5 Electromagnetic effects",
            "open": false,
            "children": [
              {
                "name": "4.5.1 Electromagnetic induction",
                "open": false,
                "children": []
              },
              {
                "name": "4.5.2 The a.c. generator",
                "open": false,
                "children": []
              },
              {
                "name": "4.5.3 Magnetic effect of a current",
                "open": false,
                "children": []
              },
              {
                "name": "4.5.4 Force on a current-carrying conductor",
                "open": false,
                "children": []
              },
              {
                "name": "4.5.5 The d.c. motor",
                "open": false,
                "children": []
              },
              {
                "name": "4.5.6 The transformer",
                "open": false,
                "children": []
              }
            ]
          }
        ]
      },
      {
        "name": "5 Nuclear physics",
        "open": false,
        "children": [
          {
            "name": "5.1 The nuclear model of the atom",
            "open": false,
            "children": [
              {
                "name": "5.1.1 The atom",
                "open": false,
                "children": []
              },
              {
                "name": "5.1.2 The nucleus",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "5.2 Radioactivity",
            "open": false,
            "children": [
              {
                "name": "5.2.1 Detection of radioactivity",
                "open": false,
                "children": []
              },
              {
                "name": "5.2.2 The three types of nuclear emission",
                "open": false,
                "children": []
              },
              {
                "name": "5.2.3 Radioactive decay",
                "open": false,
                "children": []
              },
              {
                "name": "5.2.4 Half-life",
                "open": false,
                "children": []
              },
              {
                "name": "5.2.5 Safety precautions",
                "open": false,
                "children": []
              }
            ]
          }
        ]
      },
      {
        "name": "6 Space physics",
        "open": false,
        "children": [
          {
            "name": "6.1 Earth and the Solar System",
            "open": false,
            "children": [
              {
                "name": "6.1.1 The Earth",
                "open": false,
                "children": []
              },
              {
                "name": "6.1.2 The Solar System",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "6.2 Stars and the Universe",
            "open": false,
            "children": [
              {
                "name": "6.2.1 The Sun as a star",
                "open": false,
                "children": []
              },
              {
                "name": "6.2.2 Stars",
                "open": false,
                "children": []
              },
              {
                "name": "6.2.3 The Universe",
                "open": false,
                "children": []
              }
            ]
          }
        ]
      },
      {
        "name": "7 Practical skills",
        "open": false,
        "children": [
          {
            "name": "7.1 Planning investigations",
            "open": false,
            "children": []
          },
          {
            "name": "7.2 Apparatus, measurements and safety",
            "open": false,
            "children": []
          },
          {
            "name": "7.3 Tables, graphs and data analysis",
            "open": false,
            "children": []
          },
          {
            "name": "7.4 Evaluation, accuracy, precision and improvements",
            "open": false,
            "children": []
          }
        ]
      }
    ],
    "deckCount": 83
  },
  "Edexcel GCSE Physics (1PH0)": {
    "root": "Edexcel GCSE Physics (1PH0)",
    "open": true,
    "papers": [
      {
        "name": "Practical Skills",
        "open": false,
        "children": [
          {
            "name": "CP1 – Investigate the relationship between force, mass and acceleration by varying the masses added to trolleys",
            "open": false,
            "children": []
          },
          {
            "name": "CP2 – Investigate the suitability of equipment to measure the speed, frequency and wavelength of a wave in a solid and a fluid",
            "open": false,
            "children": []
          },
          {
            "name": "CP3 – Investigate refraction in rectangular glass blocks in terms of the interaction of electromagnetic waves with matter",
            "open": false,
            "children": []
          },
          {
            "name": "CP4 – Investigate how the nature of a surface affects the amount of thermal energy radiated or absorbed",
            "open": false,
            "children": []
          },
          {
            "name": "CP5 – Construct electrical circuits to investigate current–potential difference relationships and test series and parallel circuits",
            "open": false,
            "children": []
          },
          {
            "name": "CP6 – Investigate the densities of solids and liquids",
            "open": false,
            "children": []
          },
          {
            "name": "CP7 – Determine the specific heat capacity of water and obtain a temperature–time graph for melting ice",
            "open": false,
            "children": []
          },
          {
            "name": "CP8 – Investigate the extension and work done when applying forces to a spring",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "Topic 01 – Key concepts of physics",
        "open": false,
        "children": []
      },
      {
        "name": "Topic 02 – Motion and forces",
        "open": false,
        "children": []
      },
      {
        "name": "Topic 03 – Conservation of energy",
        "open": false,
        "children": []
      },
      {
        "name": "Topic 04 – Waves",
        "open": false,
        "children": []
      },
      {
        "name": "Topic 05 – Light and the electromagnetic spectrum",
        "open": false,
        "children": []
      },
      {
        "name": "Topic 06 – Radioactivity",
        "open": false,
        "children": []
      },
      {
        "name": "Topic 07 – Astronomy",
        "open": false,
        "children": []
      },
      {
        "name": "Topic 08 – Energy – forces doing work",
        "open": false,
        "children": []
      },
      {
        "name": "Topic 09 – Forces and their effects",
        "open": false,
        "children": []
      },
      {
        "name": "Topic 10 – Electricity and circuits",
        "open": false,
        "children": []
      },
      {
        "name": "Topic 11 – Static electricity",
        "open": false,
        "children": []
      },
      {
        "name": "Topic 12 – Magnetism and the motor effect",
        "open": false,
        "children": []
      },
      {
        "name": "Topic 13 – Electromagnetic induction",
        "open": false,
        "children": []
      },
      {
        "name": "Topic 14 – Particle model",
        "open": false,
        "children": []
      },
      {
        "name": "Topic 15 – Forces and matter",
        "open": false,
        "children": []
      }
    ],
    "deckCount": 25
  },
  "Pearson Edexcel International GCSE Physics (4PH1)": {
    "root": "Pearson Edexcel International GCSE Physics (4PH1)",
    "open": true,
    "papers": [
      {
        "name": "01 Forces and motion",
        "open": false,
        "children": [
          {
            "name": "c Forces, movement, shape and momentum",
            "open": false,
            "children": []
          },
          {
            "name": "Forces, shape and momentum",
            "open": false,
            "children": []
          },
          {
            "name": "Movement and position",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "02 Electricity",
        "open": false,
        "children": [
          {
            "name": "c Energy and voltage in circuits",
            "open": false,
            "children": []
          },
          {
            "name": "Electric charge",
            "open": false,
            "children": []
          },
          {
            "name": "Energy and voltage in circuits",
            "open": false,
            "children": []
          },
          {
            "name": "Mains electricity",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "03 Waves",
        "open": false,
        "children": [
          {
            "name": "Light and sound",
            "open": false,
            "children": []
          },
          {
            "name": "Properties of waves",
            "open": false,
            "children": []
          },
          {
            "name": "The electromagnetic spectrum",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "04 Energy resources and energy transfers",
        "open": false,
        "children": [
          {
            "name": "Energy resources and electricity generation",
            "open": false,
            "children": []
          },
          {
            "name": "Energy transfers",
            "open": false,
            "children": []
          },
          {
            "name": "Work and power",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "05 Solids, liquids and gases",
        "open": false,
        "children": [
          {
            "name": "Change of state",
            "open": false,
            "children": []
          },
          {
            "name": "Density and pressure",
            "open": false,
            "children": []
          },
          {
            "name": "Ideal gas molecules",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "06 Magnetism and electromagnetism",
        "open": false,
        "children": [
          {
            "name": "c Electromagnetism",
            "open": false,
            "children": []
          },
          {
            "name": "Electromagnetic induction",
            "open": false,
            "children": []
          },
          {
            "name": "Electromagnetism",
            "open": false,
            "children": []
          },
          {
            "name": "Magnetism",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "07 Radioactivity and particles",
        "open": false,
        "children": [
          {
            "name": "Fission and fusion",
            "open": false,
            "children": []
          },
          {
            "name": "Radioactivity",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "08 Astrophysics",
        "open": false,
        "children": [
          {
            "name": "c Stellar evolution",
            "open": false,
            "children": []
          },
          {
            "name": "Cosmology",
            "open": false,
            "children": []
          },
          {
            "name": "d Cosmology",
            "open": false,
            "children": []
          },
          {
            "name": "Motion in the universe",
            "open": false,
            "children": []
          },
          {
            "name": "Stellar evolution",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "09 Practical Skills",
        "open": false,
        "children": [
          {
            "name": "01 Investigating motion of everyday objects",
            "open": false,
            "children": []
          },
          {
            "name": "02 Force and extension",
            "open": false,
            "children": []
          },
          {
            "name": "03 I-V characteristics",
            "open": false,
            "children": []
          },
          {
            "name": "04 Charging insulators by friction",
            "open": false,
            "children": []
          },
          {
            "name": "05 Refraction through blocks and prisms",
            "open": false,
            "children": []
          },
          {
            "name": "06 Refractive index of glass",
            "open": false,
            "children": []
          },
          {
            "name": "07 Speed of sound in air",
            "open": false,
            "children": []
          },
          {
            "name": "08 Sound frequency using an oscilloscope",
            "open": false,
            "children": []
          },
          {
            "name": "09 Conduction, convection and radiation",
            "open": false,
            "children": []
          },
          {
            "name": "10 Measuring density",
            "open": false,
            "children": []
          },
          {
            "name": "11 Temperature-time graph during a change of state",
            "open": false,
            "children": []
          },
          {
            "name": "12 Specific heat capacity",
            "open": false,
            "children": []
          },
          {
            "name": "13 Magnetic field patterns",
            "open": false,
            "children": []
          },
          {
            "name": "14 Penetration of alpha, beta and gamma radiation",
            "open": false,
            "children": []
          },
          {
            "name": "16 General practical and data skills",
            "open": false,
            "children": []
          }
        ]
      }
    ],
    "deckCount": 52
  },
  "OCR A A-Level Chemistry H432": {
    "root": "OCR A A-Level Chemistry H432",
    "open": true,
    "papers": [
      {
        "name": "01 Module 1 — Development of Practical Skills in Chemistry",
        "open": false,
        "children": [
          {
            "name": "01 Practical Skills Assessed in a Written Examination",
            "open": false,
            "children": [
              {
                "name": "01 Planning",
                "open": false,
                "children": []
              },
              {
                "name": "02 Implementing",
                "open": false,
                "children": []
              },
              {
                "name": "03 Analysis",
                "open": false,
                "children": []
              },
              {
                "name": "04 Evaluation",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "02 Practical Skills Assessed in the Practical Endorsement",
            "open": false,
            "children": [
              {
                "name": "01 Practical Skills",
                "open": false,
                "children": []
              },
              {
                "name": "02 Use Of Apparatus And Techniques",
                "open": false,
                "children": []
              }
            ]
          }
        ]
      },
      {
        "name": "02 Module 2 — Foundations in Chemistry",
        "open": false,
        "children": [
          {
            "name": "01 Atoms and Reactions",
            "open": false,
            "children": [
              {
                "name": "01 Atomic Structure And Isotopes",
                "open": false,
                "children": []
              },
              {
                "name": "02 Compounds, Formulae And Equations",
                "open": false,
                "children": []
              },
              {
                "name": "03 Amount Of Substance",
                "open": false,
                "children": []
              },
              {
                "name": "04 Acids",
                "open": false,
                "children": []
              },
              {
                "name": "05 Redox",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "02 Electrons, Bonding and Structure",
            "open": false,
            "children": [
              {
                "name": "01 Electron Structure",
                "open": false,
                "children": []
              },
              {
                "name": "02 Bonding And Structure",
                "open": false,
                "children": []
              }
            ]
          }
        ]
      },
      {
        "name": "03 Module 3 — Periodic Table and Energy",
        "open": false,
        "children": [
          {
            "name": "01 The Periodic Table and Periodicity",
            "open": false,
            "children": [
              {
                "name": "01 Periodicity",
                "open": false,
                "children": []
              },
              {
                "name": "02 Group 2",
                "open": false,
                "children": []
              },
              {
                "name": "03 The Halogens",
                "open": false,
                "children": []
              },
              {
                "name": "04 Qualitative Analysis",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "02 Physical Chemistry",
            "open": false,
            "children": [
              {
                "name": "01 Enthalpy Changes",
                "open": false,
                "children": []
              },
              {
                "name": "02 Reaction Rates",
                "open": false,
                "children": []
              },
              {
                "name": "03 Chemical Equilibrium",
                "open": false,
                "children": []
              }
            ]
          }
        ]
      },
      {
        "name": "04 Module 4 — Core Organic Chemistry",
        "open": false,
        "children": [
          {
            "name": "01 Basic Concepts and Hydrocarbons",
            "open": false,
            "children": [
              {
                "name": "01 Basic Concepts of Organic Chemistry",
                "open": false,
                "children": []
              },
              {
                "name": "02 Alkanes",
                "open": false,
                "children": []
              },
              {
                "name": "03 Alkenes",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "02 Alcohols, Haloalkanes and Analysis",
            "open": false,
            "children": [
              {
                "name": "01 Alcohols",
                "open": false,
                "children": []
              },
              {
                "name": "02 Haloalkanes",
                "open": false,
                "children": []
              },
              {
                "name": "03 Organic Synthesis",
                "open": false,
                "children": []
              },
              {
                "name": "04 Analytical Techniques",
                "open": false,
                "children": []
              }
            ]
          }
        ]
      },
      {
        "name": "05 Module 5 — Physical Chemistry and Transition Elements",
        "open": false,
        "children": [
          {
            "name": "01 Rates, Equilibrium and pH",
            "open": false,
            "children": [
              {
                "name": "01 How Fast?",
                "open": false,
                "children": []
              },
              {
                "name": "02 How Far?",
                "open": false,
                "children": []
              },
              {
                "name": "03 Acids, Bases and Buffers",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "02 Energy",
            "open": false,
            "children": [
              {
                "name": "01 Lattice Enthalpy",
                "open": false,
                "children": []
              },
              {
                "name": "02 Enthalpy and Entropy",
                "open": false,
                "children": []
              },
              {
                "name": "03 Redox and Electrode Potentials",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "03 Transition Elements",
            "open": false,
            "children": [
              {
                "name": "01 Transition Elements",
                "open": false,
                "children": []
              },
              {
                "name": "02 Qualitative Analysis",
                "open": false,
                "children": []
              }
            ]
          }
        ]
      },
      {
        "name": "06 Module 6 — Organic Chemistry and Analysis",
        "open": false,
        "children": [
          {
            "name": "01 Aromatic Compounds, Carbonyls and Acids",
            "open": false,
            "children": [
              {
                "name": "01 Aromatic Compounds",
                "open": false,
                "children": []
              },
              {
                "name": "02 Carbonyl Compounds",
                "open": false,
                "children": []
              },
              {
                "name": "03 Carboxylic Acids And Esters",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "02 Nitrogen Compounds, Polymers and Synthesis",
            "open": false,
            "children": [
              {
                "name": "01 Amines",
                "open": false,
                "children": []
              },
              {
                "name": "02 Amino Acids, Amides And Chirality",
                "open": false,
                "children": []
              },
              {
                "name": "03 Polyesters And Polyamides",
                "open": false,
                "children": []
              },
              {
                "name": "04 Carbon–Carbon Bond Formation",
                "open": false,
                "children": []
              },
              {
                "name": "05 Organic Synthesis",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "03 Analysis",
            "open": false,
            "children": [
              {
                "name": "01 Chromatography And Qualitative Analysis",
                "open": false,
                "children": []
              },
              {
                "name": "02 Spectroscopy",
                "open": false,
                "children": []
              }
            ]
          }
        ]
      },
      {
        "name": "07 Practical Activities — PAG 01–12",
        "open": false,
        "children": [
          {
            "name": "01 PAG 01 — Moles Determination",
            "open": false,
            "children": []
          },
          {
            "name": "02 PAG 02 — Acid–Base Titration",
            "open": false,
            "children": []
          },
          {
            "name": "03 PAG 03 — Enthalpy Determination",
            "open": false,
            "children": []
          },
          {
            "name": "04 PAG 04 — Qualitative Analysis of Ions",
            "open": false,
            "children": []
          },
          {
            "name": "05 PAG 05 — Synthesis of an Organic Liquid",
            "open": false,
            "children": []
          },
          {
            "name": "06 PAG 06 — Synthesis of an Organic Solid",
            "open": false,
            "children": []
          },
          {
            "name": "07 PAG 07 — Organic Functional-Group Analysis",
            "open": false,
            "children": []
          },
          {
            "name": "08 PAG 08 — Electrochemical Cells",
            "open": false,
            "children": []
          },
          {
            "name": "09 PAG 09 — Rates by Continuous Monitoring",
            "open": false,
            "children": []
          },
          {
            "name": "10 PAG 10 — Rates by Initial-Rate Methods",
            "open": false,
            "children": []
          },
          {
            "name": "11 PAG 11 — pH Measurement",
            "open": false,
            "children": []
          },
          {
            "name": "12 PAG 12 — Research Skills",
            "open": false,
            "children": []
          }
        ]
      }
    ],
    "deckCount": 79
  },
  "OCR B A-Level Physics": {
    "root": "OCR B A-Level Physics",
    "open": true,
    "papers": [
      {
        "name": "Module 1 - Practical Skills in Physics",
        "open": false,
        "children": [
          {
            "name": "1.1 Practical Skills",
            "open": false,
            "children": []
          },
          {
            "name": "PAG 01.1 Comparing methods of determining g",
            "open": false,
            "children": []
          },
          {
            "name": "PAG 01.2 Investigating terminal velocity",
            "open": false,
            "children": []
          },
          {
            "name": "PAG 01.3 Investigating initial speed and stopping distance",
            "open": false,
            "children": []
          },
          {
            "name": "PAG 02.1 Determining Young Modulus",
            "open": false,
            "children": []
          },
          {
            "name": "PAG 02.2 Investigating springs in series and parallel",
            "open": false,
            "children": []
          },
          {
            "name": "PAG 02.3 Investigating a property of plastic",
            "open": false,
            "children": []
          },
          {
            "name": "PAG 03.1 Determination of resistivity",
            "open": false,
            "children": []
          },
          {
            "name": "PAG 03.2 Investigating electrical characteristics",
            "open": false,
            "children": []
          },
          {
            "name": "PAG 03.3 Determining internal resistance and maximum power",
            "open": false,
            "children": []
          },
          {
            "name": "PAG 04.1 Investigating resistance",
            "open": false,
            "children": []
          },
          {
            "name": "PAG 04.2 Investigating circuits with several sources of emf",
            "open": false,
            "children": []
          },
          {
            "name": "PAG 04.3 Using non-ohmic devices as sensors",
            "open": false,
            "children": []
          },
          {
            "name": "PAG 05.1 Diffraction grating",
            "open": false,
            "children": []
          },
          {
            "name": "PAG 05.2 Speed of sound",
            "open": false,
            "children": []
          },
          {
            "name": "PAG 05.3 Oscilloscope",
            "open": false,
            "children": []
          },
          {
            "name": "PAG 05.4 Diffraction using a CD",
            "open": false,
            "children": []
          },
          {
            "name": "PAG 06.1 Planck constant",
            "open": false,
            "children": []
          },
          {
            "name": "PAG 06.2 Experiments with light",
            "open": false,
            "children": []
          },
          {
            "name": "PAG 06.3 Polarisation",
            "open": false,
            "children": []
          },
          {
            "name": "PAG 07.1 Random radioactive decay",
            "open": false,
            "children": []
          },
          {
            "name": "PAG 07.2 Absorption of ionising radiation",
            "open": false,
            "children": []
          },
          {
            "name": "PAG 07.3 Determining half-life",
            "open": false,
            "children": []
          },
          {
            "name": "PAG 08.1 Absolute zero",
            "open": false,
            "children": []
          },
          {
            "name": "PAG 08.2 Pressure-volume relationship",
            "open": false,
            "children": []
          },
          {
            "name": "PAG 08.3 Work done by a gas",
            "open": false,
            "children": []
          },
          {
            "name": "PAG 09.1 Charging and discharging capacitors",
            "open": false,
            "children": []
          },
          {
            "name": "PAG 09.2 Capacitors in series and parallel",
            "open": false,
            "children": []
          },
          {
            "name": "PAG 09.3 Capacitance",
            "open": false,
            "children": []
          },
          {
            "name": "PAG 10.1 Factors affecting SHM",
            "open": false,
            "children": []
          },
          {
            "name": "PAG 10.2 Forced and damped oscillations",
            "open": false,
            "children": []
          },
          {
            "name": "PAG 10.3 Determining spring stiffness",
            "open": false,
            "children": []
          },
          {
            "name": "PAG 11.1 Transformers",
            "open": false,
            "children": []
          },
          {
            "name": "PAG 11.2 Specific heat capacity",
            "open": false,
            "children": []
          },
          {
            "name": "PAG 11.3 Magnetic field of a magnet",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "Module 2 - Fundamental Data Analysis",
        "open": false,
        "children": [
          {
            "name": "2.1 Quantities and Units",
            "open": false,
            "children": []
          },
          {
            "name": "2.2 Making Measurements",
            "open": false,
            "children": []
          },
          {
            "name": "2.3 Presenting Data",
            "open": false,
            "children": []
          },
          {
            "name": "2.4 Analysing Data",
            "open": false,
            "children": []
          },
          {
            "name": "2.5 Using Data",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "Module 3 - Physics in Action",
        "open": false,
        "children": [
          {
            "name": "3.1 Imaging and Signalling",
            "open": false,
            "children": [
              {
                "name": "3.1.1 Imaging and Signalling",
                "open": false,
                "children": []
              },
              {
                "name": "3.1.2 Polarisation",
                "open": false,
                "children": []
              },
              {
                "name": "3.1.3 Sensing",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "3.2 Mechanical Properties of Materials",
            "open": false,
            "children": [
              {
                "name": "3.2.1 Materials",
                "open": false,
                "children": []
              },
              {
                "name": "3.2.2 Mechanical Properties",
                "open": false,
                "children": []
              }
            ]
          }
        ]
      },
      {
        "name": "Module 4 - Understanding Processes",
        "open": false,
        "children": [
          {
            "name": "4.1 Waves and Quantum Behaviour",
            "open": false,
            "children": [
              {
                "name": "4.1.1 Wave Behaviour",
                "open": false,
                "children": []
              },
              {
                "name": "4.1.2 Particle Theory of Light",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "4.2 Space, Time and Motion",
            "open": false,
            "children": [
              {
                "name": "4.2.1 Mechanics",
                "open": false,
                "children": []
              },
              {
                "name": "4.2.2 Motion",
                "open": false,
                "children": []
              }
            ]
          }
        ]
      },
      {
        "name": "Module 5 - Rise and Fall of the Clockwork Universe",
        "open": false,
        "children": [
          {
            "name": "5.1 Creating Models",
            "open": false,
            "children": [
              {
                "name": "5.1.1 Radioactive Decay",
                "open": false,
                "children": []
              },
              {
                "name": "5.1.2 Capacitors",
                "open": false,
                "children": []
              },
              {
                "name": "5.1.3 Circular Motion & SHM",
                "open": false,
                "children": []
              },
              {
                "name": "5.1.4 Gravitational Fields",
                "open": false,
                "children": []
              },
              {
                "name": "5.1.5 Space & Relativity",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "5.2 Matter",
            "open": false,
            "children": [
              {
                "name": "5.2.1 Gas Laws",
                "open": false,
                "children": []
              },
              {
                "name": "5.2.2 Thermal Physics",
                "open": false,
                "children": []
              }
            ]
          }
        ]
      },
      {
        "name": "Module 6 - Field and Particle Physics",
        "open": false,
        "children": [
          {
            "name": "6.1 Fields",
            "open": false,
            "children": [
              {
                "name": "6.1.1 Magnetic Fields",
                "open": false,
                "children": []
              },
              {
                "name": "6.1.2 Transformers",
                "open": false,
                "children": []
              },
              {
                "name": "6.1.3 Motor Effect",
                "open": false,
                "children": []
              },
              {
                "name": "6.1.4 Electric Fields",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "6.2 Fundamental Particles",
            "open": false,
            "children": [
              {
                "name": "6.2.1 Atomic Models",
                "open": false,
                "children": []
              },
              {
                "name": "6.2.2 Particle Types",
                "open": false,
                "children": []
              },
              {
                "name": "6.2.3 Particle Accelerators",
                "open": false,
                "children": []
              },
              {
                "name": "6.2.4 Nuclear Radiation",
                "open": false,
                "children": []
              },
              {
                "name": "6.2.5 Nuclear Energy",
                "open": false,
                "children": []
              },
              {
                "name": "6.2.6 Cosmology",
                "open": false,
                "children": []
              }
            ]
          }
        ]
      }
    ],
    "deckCount": 81
  },
  "OCR B Twenty First Century Science GCSE Chemistry (J258)": {
    "root": "OCR B Twenty First Century Science GCSE Chemistry (J258)",
    "open": true,
    "papers": [
      {
        "name": "01 Air and water",
        "open": false,
        "children": [
          {
            "name": "C1.1 How has the Earth's atmosphere changed over time, and why?",
            "open": false,
            "children": []
          },
          {
            "name": "C1.2 Why are there temperature changes in chemical reactions?",
            "open": false,
            "children": []
          },
          {
            "name": "C1.3 What is the evidence for climate change, and why is it occurring?",
            "open": false,
            "children": []
          },
          {
            "name": "C1.4 How can scientists help improve the supply of potable water?",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "02 Chemical patterns",
        "open": false,
        "children": [
          {
            "name": "C2.1 How have our ideas about atoms developed over time?",
            "open": false,
            "children": []
          },
          {
            "name": "C2.2 What does the Periodic Table tell us about the elements?",
            "open": false,
            "children": []
          },
          {
            "name": "C2.3 How do metals and non-metals combine to form compounds?",
            "open": false,
            "children": []
          },
          {
            "name": "C2.4 How are equations used to represent chemical reactions?",
            "open": false,
            "children": []
          },
          {
            "name": "C2.5 What are the properties of transition metals?",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "03 Chemicals of the natural environment",
        "open": false,
        "children": [
          {
            "name": "C3.1 How are the atoms held together in a metal?",
            "open": false,
            "children": []
          },
          {
            "name": "C3.2 How are metals with different reactivities extracted?",
            "open": false,
            "children": []
          },
          {
            "name": "C3.3 What are electrolytes and what happens during electrolysis?",
            "open": false,
            "children": []
          },
          {
            "name": "C3.4 Why is crude oil important as a source of new materials?",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "04 Material choices",
        "open": false,
        "children": [
          {
            "name": "C4.1 How is data used to choose a material for a particular use?",
            "open": false,
            "children": []
          },
          {
            "name": "C4.2 What are the different types of polymers?",
            "open": false,
            "children": []
          },
          {
            "name": "C4.3 How do bonding and structure affect properties of materials?",
            "open": false,
            "children": []
          },
          {
            "name": "C4.4 Why are nanoparticles so useful?",
            "open": false,
            "children": []
          },
          {
            "name": "C4.5 What happens to products at the end of their useful life?",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "05 Chemical analysis",
        "open": false,
        "children": [
          {
            "name": "C5.1 How are chemicals separated and tested for purity?",
            "open": false,
            "children": []
          },
          {
            "name": "C5.2 How do chemists find the composition of unknown samples?",
            "open": false,
            "children": []
          },
          {
            "name": "C5.3 How are the amounts of substances in reactions calculated?",
            "open": false,
            "children": []
          },
          {
            "name": "C5.4 How are the amounts of chemicals in solution measured?",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "06 Making useful chemicals",
        "open": false,
        "children": [
          {
            "name": "C6.1 What useful products can be made from acids?",
            "open": false,
            "children": []
          },
          {
            "name": "C6.2 How do chemists control the rate of reactions?",
            "open": false,
            "children": []
          },
          {
            "name": "C6.3 What factors affect the yield of chemical reactions?",
            "open": false,
            "children": []
          },
          {
            "name": "C6.4 How are chemicals made on an industrial scale?",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "07 Ideas about Science",
        "open": false,
        "children": [
          {
            "name": "IaS1 What needs to be considered when investigating a phenomenon scientifically?",
            "open": false,
            "children": []
          },
          {
            "name": "IaS2 What processes are needed to draw conclusions from data?",
            "open": false,
            "children": []
          },
          {
            "name": "IaS3 How are scientific explanations developed?",
            "open": false,
            "children": []
          },
          {
            "name": "IaS4 How do science and technology impact society?",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "08 Practical skills",
        "open": false,
        "children": [
          {
            "name": "PAG1 Reactivity trend",
            "open": false,
            "children": []
          },
          {
            "name": "PAG2 Electrolysis",
            "open": false,
            "children": []
          },
          {
            "name": "PAG3 Separation techniques",
            "open": false,
            "children": []
          },
          {
            "name": "PAG4 Distillation",
            "open": false,
            "children": []
          },
          {
            "name": "PAG5 Identification of species",
            "open": false,
            "children": []
          },
          {
            "name": "PAG6 Titration",
            "open": false,
            "children": []
          },
          {
            "name": "PAG7 Production of salts",
            "open": false,
            "children": []
          },
          {
            "name": "PAG8 Measuring rates of reaction",
            "open": false,
            "children": []
          }
        ]
      }
    ],
    "deckCount": 47
  },
  "OCR B GCSE Physics": {
    "root": "OCR B GCSE Physics",
    "open": true,
    "papers": [
      {
        "name": "01 - P1 Radiation & Waves",
        "open": false,
        "children": [
          {
            "name": "P1.1 Radiation Risks & Benefits",
            "open": false,
            "children": []
          },
          {
            "name": "P1.2 Climate Change Evidence",
            "open": false,
            "children": []
          },
          {
            "name": "P1.3 Wave Behaviour",
            "open": false,
            "children": []
          },
          {
            "name": "P1.4 Light, Sound & Materials",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "02 - P2 Sustainable Energy",
        "open": false,
        "children": [
          {
            "name": "P2.1 Energy Use",
            "open": false,
            "children": []
          },
          {
            "name": "P2.2 Electricity Generation",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "03 - P3 Electric Circuits",
        "open": false,
        "children": [
          {
            "name": "P3.1 Electric Charge",
            "open": false,
            "children": []
          },
          {
            "name": "P3.2 Current & Resistance",
            "open": false,
            "children": []
          },
          {
            "name": "P3.3 Series & Parallel Circuits",
            "open": false,
            "children": []
          },
          {
            "name": "P3.4 Electrical Energy & Power",
            "open": false,
            "children": []
          },
          {
            "name": "P3.5 Magnetic Fields",
            "open": false,
            "children": []
          },
          {
            "name": "P3.6 Electric Motors",
            "open": false,
            "children": []
          },
          {
            "name": "P3.7 Generators & Transformers",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "04 - P4 Explaining Motion",
        "open": false,
        "children": [
          {
            "name": "P4.1 Forces",
            "open": false,
            "children": []
          },
          {
            "name": "P4.2 Describing Motion",
            "open": false,
            "children": []
          },
          {
            "name": "P4.3 Forces & Motion",
            "open": false,
            "children": []
          },
          {
            "name": "P4.4 Energy in Motion",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "05 - P5 Radioactive Materials",
        "open": false,
        "children": [
          {
            "name": "P5.1 Radioactivity",
            "open": false,
            "children": []
          },
          {
            "name": "P5.2 Safe Use of Radioactive Materials",
            "open": false,
            "children": []
          },
          {
            "name": "P5.3 Nuclear Energy",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "06 - P6 Matter & Models",
        "open": false,
        "children": [
          {
            "name": "P6.1 Energy & Changes of State",
            "open": false,
            "children": []
          },
          {
            "name": "P6.2 Heating & the Particle Model",
            "open": false,
            "children": []
          },
          {
            "name": "P6.3 Materials Under Stress",
            "open": false,
            "children": []
          },
          {
            "name": "P6.4 Pressure in Fluids",
            "open": false,
            "children": []
          },
          {
            "name": "P6.5 The Big Bang",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "07 - Ideas About Science",
        "open": false,
        "children": [
          {
            "name": "IaS1 Planning Investigations",
            "open": false,
            "children": []
          },
          {
            "name": "IaS2 Analysing Data",
            "open": false,
            "children": []
          },
          {
            "name": "IaS3 Developing Explanations",
            "open": false,
            "children": []
          },
          {
            "name": "IaS4 Science & Society",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "08 - Practical Skills",
        "open": false,
        "children": [
          {
            "name": "PAG1 Materials",
            "open": false,
            "children": []
          },
          {
            "name": "PAG2 Forces",
            "open": false,
            "children": []
          },
          {
            "name": "PAG3 Motion",
            "open": false,
            "children": []
          },
          {
            "name": "PAG4 Measuring Waves",
            "open": false,
            "children": []
          },
          {
            "name": "PAG5 Energy",
            "open": false,
            "children": []
          },
          {
            "name": "PAG6 Circuit Components",
            "open": false,
            "children": []
          },
          {
            "name": "PAG7 Series & Parallel Circuits",
            "open": false,
            "children": []
          },
          {
            "name": "PAG8 Wave Interactions",
            "open": false,
            "children": []
          }
        ]
      }
    ],
    "deckCount": 46
  },
  "OCR B (Salters) A-Level Chemistry H433": {
    "root": "OCR B (Salters) A-Level Chemistry H433",
    "open": true,
    "papers": [
      {
        "name": "01 Elements of Life",
        "open": false,
        "children": [
          {
            "name": "01 Amount of substance, equations and titrations",
            "open": false,
            "children": []
          },
          {
            "name": "02 Atomic structure, orbitals and electron configurations",
            "open": false,
            "children": []
          },
          {
            "name": "03 Atomic models, fusion, spectra and mass spectrometry",
            "open": false,
            "children": []
          },
          {
            "name": "04 Bonding, structures and molecular shapes",
            "open": false,
            "children": []
          },
          {
            "name": "05 Periodicity, Group 2 and ionisation enthalpy",
            "open": false,
            "children": []
          },
          {
            "name": "06 Ions, precipitation tests and salt preparation",
            "open": false,
            "children": []
          },
          {
            "name": "07 Acids, bases and Group 2 oxides/hydroxides",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "02 Developing Fuels",
        "open": false,
        "children": [
          {
            "name": "01 Gases, moles and fuel calculations",
            "open": false,
            "children": []
          },
          {
            "name": "02 Organic bonding, shapes and formulae",
            "open": false,
            "children": []
          },
          {
            "name": "03 Enthalpy changes, calorimetry and Hess cycles",
            "open": false,
            "children": []
          },
          {
            "name": "04 Catalysts, cracking and atmospheric pollutants",
            "open": false,
            "children": []
          },
          {
            "name": "05 Alkanes, alkenes and addition reactions",
            "open": false,
            "children": []
          },
          {
            "name": "06 Electrophilic addition mechanisms",
            "open": false,
            "children": []
          },
          {
            "name": "07 Addition polymers, E/Z isomerism and sustainability",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "03 Elements from the Sea",
        "open": false,
        "children": [
          {
            "name": "01 Industrial quantities and atom economy",
            "open": false,
            "children": []
          },
          {
            "name": "02 Aqueous electrolysis",
            "open": false,
            "children": []
          },
          {
            "name": "03 Oxidation states, half-equations and redox equations",
            "open": false,
            "children": []
          },
          {
            "name": "04 Halogen trends, displacement and halide tests",
            "open": false,
            "children": []
          },
          {
            "name": "05 Hydrogen halides",
            "open": false,
            "children": []
          },
          {
            "name": "06 Dynamic equilibrium and Kc",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "04 The Ozone Story",
        "open": false,
        "children": [
          {
            "name": "01 Electronegativity, polarity and intermolecular bonding",
            "open": false,
            "children": []
          },
          {
            "name": "02 Activation enthalpy, rates and catalysts",
            "open": false,
            "children": []
          },
          {
            "name": "03 Haloalkanes and nucleophilic substitution",
            "open": false,
            "children": []
          },
          {
            "name": "04 Bond fission and radical substitution",
            "open": false,
            "children": []
          },
          {
            "name": "05 Atmospheric composition, ozone chemistry and CFC catalysis",
            "open": false,
            "children": []
          },
          {
            "name": "06 Electromagnetic radiation and photochemistry",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "05 What's in a Medicine?",
        "open": false,
        "children": [
          {
            "name": "01 Alcohols, phenols and carboxylic acids",
            "open": false,
            "children": []
          },
          {
            "name": "02 Esterification, oxidation and elimination",
            "open": false,
            "children": []
          },
          {
            "name": "03 Organic liquid and solid preparation",
            "open": false,
            "children": []
          },
          {
            "name": "04 Green chemistry and process evaluation",
            "open": false,
            "children": []
          },
          {
            "name": "05 Mass spectrometry and infrared spectroscopy",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "06 The Chemical Industry",
        "open": false,
        "children": [
          {
            "name": "01 Rate equations, orders and half-lives",
            "open": false,
            "children": []
          },
          {
            "name": "02 Arrhenius analysis and activation enthalpy",
            "open": false,
            "children": []
          },
          {
            "name": "03 Rate-determining steps",
            "open": false,
            "children": []
          },
          {
            "name": "04 Equilibrium, Kc and economic conditions",
            "open": false,
            "children": []
          },
          {
            "name": "05 Nitrogen chemistry and ion tests",
            "open": false,
            "children": []
          },
          {
            "name": "06 Industrial-process evidence and sustainability",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "07 Polymers and Life",
        "open": false,
        "children": [
          {
            "name": "01 Amino acids, peptides and proteins",
            "open": false,
            "children": []
          },
          {
            "name": "02 DNA, RNA and genetic information flow",
            "open": false,
            "children": []
          },
          {
            "name": "03 Molecular recognition and enzyme catalysis",
            "open": false,
            "children": []
          },
          {
            "name": "04 Carboxylic acids, amines and amino-acid acid–base chemistry",
            "open": false,
            "children": []
          },
          {
            "name": "05 Esters, amides, acyl chlorides and hydrolysis",
            "open": false,
            "children": []
          },
          {
            "name": "06 Addition and condensation polymers",
            "open": false,
            "children": []
          },
          {
            "name": "07 Optical isomerism",
            "open": false,
            "children": []
          },
          {
            "name": "08 High-resolution MS, NMR and combined spectroscopy",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "08 Oceans",
        "open": false,
        "children": [
          {
            "name": "01 Solubility and intermolecular/ion–dipole interactions",
            "open": false,
            "children": []
          },
          {
            "name": "02 Lattice enthalpy, hydration enthalpy and solution cycles",
            "open": false,
            "children": []
          },
          {
            "name": "03 Entropy and feasibility",
            "open": false,
            "children": []
          },
          {
            "name": "04 Solubility products",
            "open": false,
            "children": []
          },
          {
            "name": "05 Brønsted–Lowry acids and bases",
            "open": false,
            "children": []
          },
          {
            "name": "06 pH, weak acids and buffers",
            "open": false,
            "children": []
          },
          {
            "name": "07 Greenhouse chemistry",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "09 Developing Metals",
        "open": false,
        "children": [
          {
            "name": "01 Manganate(VII) and other titration calculations",
            "open": false,
            "children": []
          },
          {
            "name": "02 Complex shapes and coordination number",
            "open": false,
            "children": []
          },
          {
            "name": "03 Redox equations and electrochemical cells",
            "open": false,
            "children": []
          },
          {
            "name": "04 Standard electrode potentials, feasibility and rusting",
            "open": false,
            "children": []
          },
          {
            "name": "05 Transition-metal ions, configurations and complexes",
            "open": false,
            "children": []
          },
          {
            "name": "06 Ligand substitution and precipitation chemistry",
            "open": false,
            "children": []
          },
          {
            "name": "07 Transition-metal catalysis and colour",
            "open": false,
            "children": []
          },
          {
            "name": "08 Colorimetry",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "10 Colour by Design",
        "open": false,
        "children": [
          {
            "name": "01 Chromophores, dye structure and fibre bonding",
            "open": false,
            "children": []
          },
          {
            "name": "02 Fats, oils and polyfunctional molecules",
            "open": false,
            "children": []
          },
          {
            "name": "03 Benzene structure and delocalisation",
            "open": false,
            "children": []
          },
          {
            "name": "04 Electrophilic substitution and diazonium/azo chemistry",
            "open": false,
            "children": []
          },
          {
            "name": "05 Carbonyl reactions and cyanohydrin formation",
            "open": false,
            "children": []
          },
          {
            "name": "06 Organic synthesis and unfamiliar mechanisms",
            "open": false,
            "children": []
          },
          {
            "name": "07 Electronic transitions and colour",
            "open": false,
            "children": []
          },
          {
            "name": "08 Gas–liquid chromatography",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "11 Practical and Chemical Literacy",
        "open": false,
        "children": [
          {
            "name": "01 Experimental planning and variables",
            "open": false,
            "children": []
          },
          {
            "name": "02 Measurement, observations, units and records",
            "open": false,
            "children": []
          },
          {
            "name": "03 Processing, graphs, uncertainty and evaluation",
            "open": false,
            "children": []
          },
          {
            "name": "04 Advance Notice article skills",
            "open": false,
            "children": []
          },
          {
            "name": "05 Practical Insert skills",
            "open": false,
            "children": []
          },
          {
            "name": "06 Research and referencing",
            "open": false,
            "children": []
          }
        ]
      }
    ],
    "deckCount": 86
  },
  "WJEC A Level Chemistry": {
    "root": "WJEC A Level Chemistry",
    "open": true,
    "papers": [
      {
        "name": "01 Unit 1 — The Language of Chemistry, Structure of Matter and Simple Reactions",
        "open": false,
        "children": [
          {
            "name": "01 Formulae and Equations",
            "open": false,
            "children": []
          },
          {
            "name": "02 Basic Ideas About Atoms",
            "open": false,
            "children": []
          },
          {
            "name": "03 Chemical Calculations",
            "open": false,
            "children": []
          },
          {
            "name": "04 Bonding",
            "open": false,
            "children": []
          },
          {
            "name": "05 Solid Structures",
            "open": false,
            "children": []
          },
          {
            "name": "06 The Periodic Table",
            "open": false,
            "children": []
          },
          {
            "name": "07 Simple Equilibria and Acid–Base Reactions",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "02 Unit 2 — Energy, Rate and Chemistry of Carbon Compounds",
        "open": false,
        "children": [
          {
            "name": "01 Thermochemistry",
            "open": false,
            "children": []
          },
          {
            "name": "02 Rates of Reaction",
            "open": false,
            "children": []
          },
          {
            "name": "03 The Wider Impact of Chemistry",
            "open": false,
            "children": []
          },
          {
            "name": "04 Organic Compounds",
            "open": false,
            "children": []
          },
          {
            "name": "05 Hydrocarbons",
            "open": false,
            "children": []
          },
          {
            "name": "06 Halogenoalkanes",
            "open": false,
            "children": []
          },
          {
            "name": "07 Alcohols and Carboxylic Acids",
            "open": false,
            "children": []
          },
          {
            "name": "08 Instrumental Analysis",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "03 Unit 3 — Physical and Inorganic Chemistry",
        "open": false,
        "children": [
          {
            "name": "01 Redox and Standard Electrode Potential",
            "open": false,
            "children": []
          },
          {
            "name": "02 Redox Reactions",
            "open": false,
            "children": []
          },
          {
            "name": "03 Chemistry of the p-Block",
            "open": false,
            "children": []
          },
          {
            "name": "04 Chemistry of the d-Block Transition Metals",
            "open": false,
            "children": []
          },
          {
            "name": "05 Chemical Kinetics",
            "open": false,
            "children": []
          },
          {
            "name": "06 Enthalpy Changes for Solids and Solutions",
            "open": false,
            "children": []
          },
          {
            "name": "07 Entropy and Feasibility",
            "open": false,
            "children": []
          },
          {
            "name": "08 Equilibrium Constants",
            "open": false,
            "children": []
          },
          {
            "name": "09 Acid–Base Equilibria",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "04 Unit 4 — Organic Chemistry and Analysis",
        "open": false,
        "children": [
          {
            "name": "01 Stereoisomerism",
            "open": false,
            "children": []
          },
          {
            "name": "02 Aromaticity",
            "open": false,
            "children": []
          },
          {
            "name": "03 Alcohols and Phenols",
            "open": false,
            "children": []
          },
          {
            "name": "04 Aldehydes and Ketones",
            "open": false,
            "children": []
          },
          {
            "name": "05 Carboxylic Acids and Derivatives",
            "open": false,
            "children": []
          },
          {
            "name": "06 Amines",
            "open": false,
            "children": []
          },
          {
            "name": "07 Amino Acids, Peptides and Proteins",
            "open": false,
            "children": []
          },
          {
            "name": "08 Organic Synthesis and Analysis",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "05 Unit 5 — Practical",
        "open": false,
        "children": [
          {
            "name": "01 Experimental Task",
            "open": false,
            "children": []
          },
          {
            "name": "02 Practical Methods and Analysis",
            "open": false,
            "children": []
          },
          {
            "name": "03 Specified Practical Work",
            "open": false,
            "children": [
              {
                "name": "01 Gravimetric Analysis",
                "open": false,
                "children": []
              },
              {
                "name": "02 Identification of Unknown Solutions by Qualitative Analysis",
                "open": false,
                "children": []
              },
              {
                "name": "03 Preparation of a Soluble Salt by Titration",
                "open": false,
                "children": []
              },
              {
                "name": "04 Standardisation of an Acid Solution",
                "open": false,
                "children": []
              },
              {
                "name": "05 Back Titration",
                "open": false,
                "children": []
              },
              {
                "name": "06 Double Titration",
                "open": false,
                "children": []
              },
              {
                "name": "07 Indirect Determination of an Enthalpy Change",
                "open": false,
                "children": []
              },
              {
                "name": "08 Determination of Enthalpy Change of Combustion",
                "open": false,
                "children": []
              },
              {
                "name": "09 Rate by Gas Collection",
                "open": false,
                "children": []
              },
              {
                "name": "10 Iodine Clock",
                "open": false,
                "children": []
              },
              {
                "name": "11 Nucleophilic Substitution Reaction",
                "open": false,
                "children": []
              },
              {
                "name": "12 Preparation of an Ester and Separation by Distillation",
                "open": false,
                "children": []
              },
              {
                "name": "13 Construct Electrochemical Cells and Measure Ecell",
                "open": false,
                "children": []
              },
              {
                "name": "14 Simple Redox Titration",
                "open": false,
                "children": []
              },
              {
                "name": "15 Estimation of Copper in Copper(II) Salts",
                "open": false,
                "children": []
              },
              {
                "name": "16 Determine Reaction Order",
                "open": false,
                "children": []
              },
              {
                "name": "17 Determine an Equilibrium Constant",
                "open": false,
                "children": []
              },
              {
                "name": "18 pH-Probe Titration",
                "open": false,
                "children": []
              },
              {
                "name": "19 Synthesis of a Liquid Organic Product",
                "open": false,
                "children": []
              },
              {
                "name": "20 Synthesis of a Solid Organic Product",
                "open": false,
                "children": []
              },
              {
                "name": "21 Two-Step Synthesis",
                "open": false,
                "children": []
              },
              {
                "name": "22 Plan Tests to Identify Organic Compounds",
                "open": false,
                "children": []
              },
              {
                "name": "23 Paper Chromatography Including Two-Way Separation",
                "open": false,
                "children": []
              }
            ]
          }
        ]
      }
    ],
    "deckCount": 64
  },
  "WJEC A Level Physics": {
    "root": "WJEC A Level Physics",
    "open": true,
    "papers": [
      {
        "name": "Unit 1 - Motion, Energy and Matter",
        "open": false,
        "children": [
          {
            "name": "1.1 Basic Physics",
            "open": false,
            "children": []
          },
          {
            "name": "1.2 Kinematics",
            "open": false,
            "children": []
          },
          {
            "name": "1.3 Dynamics",
            "open": false,
            "children": []
          },
          {
            "name": "1.4 Energy Concepts",
            "open": false,
            "children": []
          },
          {
            "name": "1.5 Solids Under Stress",
            "open": false,
            "children": []
          },
          {
            "name": "1.6 Using Radiation to Investigate Stars",
            "open": false,
            "children": []
          },
          {
            "name": "1.7 Particles and Nuclear Structure",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "Unit 2 - Electricity and Light",
        "open": false,
        "children": [
          {
            "name": "2.1 Conduction of Electricity",
            "open": false,
            "children": []
          },
          {
            "name": "2.2 Resistance",
            "open": false,
            "children": []
          },
          {
            "name": "2.3 D.C. Circuits",
            "open": false,
            "children": []
          },
          {
            "name": "2.4 Nature of Waves",
            "open": false,
            "children": []
          },
          {
            "name": "2.5 Wave Properties",
            "open": false,
            "children": []
          },
          {
            "name": "2.6 Refraction of Light",
            "open": false,
            "children": []
          },
          {
            "name": "2.7 Photons",
            "open": false,
            "children": []
          },
          {
            "name": "2.8 Lasers",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "Unit 3 - Oscillations and Nuclei",
        "open": false,
        "children": [
          {
            "name": "3.1 Circular Motion",
            "open": false,
            "children": []
          },
          {
            "name": "3.2 Vibrations",
            "open": false,
            "children": []
          },
          {
            "name": "3.3 Kinetic Theory",
            "open": false,
            "children": []
          },
          {
            "name": "3.4 Thermal Physics",
            "open": false,
            "children": []
          },
          {
            "name": "3.5 Nuclear Decay",
            "open": false,
            "children": []
          },
          {
            "name": "3.6 Nuclear Energy",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "Unit 4 - Core",
        "open": false,
        "children": [
          {
            "name": "4.1 Capacitance",
            "open": false,
            "children": []
          },
          {
            "name": "4.2 Electrostatic and Gravitational Fields of Force",
            "open": false,
            "children": []
          },
          {
            "name": "4.3 Orbits and the Wider Universe",
            "open": false,
            "children": []
          },
          {
            "name": "4.4 Magnetic Fields",
            "open": false,
            "children": []
          },
          {
            "name": "4.5 Electromagnetic Induction",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "Unit 4 Option A - Alternating Currents",
        "open": false,
        "children": []
      },
      {
        "name": "Unit 4 Option B - Medical Physics",
        "open": false,
        "children": []
      },
      {
        "name": "Unit 4 Option C - The Physics of Sport",
        "open": false,
        "children": []
      },
      {
        "name": "Unit 4 Option D - Energy and the Environment",
        "open": false,
        "children": []
      },
      {
        "name": "Unit 5 - Practical Skills",
        "open": false,
        "children": [
          {
            "name": "Practical Skills",
            "open": false,
            "children": []
          },
          {
            "name": "SP 1.1 Basic Physics",
            "open": false,
            "children": []
          },
          {
            "name": "SP 1.2 Kinematics",
            "open": false,
            "children": []
          },
          {
            "name": "SP 1.3 Dynamics",
            "open": false,
            "children": []
          },
          {
            "name": "SP 1.5 Solids Under Stress",
            "open": false,
            "children": []
          },
          {
            "name": "SP 2.2 Resistance",
            "open": false,
            "children": []
          },
          {
            "name": "SP 2.3 D.C. Circuits",
            "open": false,
            "children": []
          },
          {
            "name": "SP 2.4 Waves",
            "open": false,
            "children": []
          },
          {
            "name": "SP 2.5 Wave Properties",
            "open": false,
            "children": []
          },
          {
            "name": "SP 2.6 Refraction of Light",
            "open": false,
            "children": []
          },
          {
            "name": "SP 2.7 Photons",
            "open": false,
            "children": []
          },
          {
            "name": "SP 3.2 Vibrations",
            "open": false,
            "children": []
          },
          {
            "name": "SP 3.4 Thermal Physics",
            "open": false,
            "children": []
          },
          {
            "name": "SP 3.5 Nuclear Decay",
            "open": false,
            "children": []
          },
          {
            "name": "SP 4.1 Capacitance",
            "open": false,
            "children": []
          },
          {
            "name": "SP 4.4 Magnetic Fields",
            "open": false,
            "children": []
          }
        ]
      }
    ],
    "deckCount": 52
  },
  "AQA A Level Physics (7408)": {
    "root": "AQA A Level Physics (7408)",
    "open": true,
    "papers": [
      {
        "name": "1.0 Paper 1",
        "open": false,
        "children": [
          {
            "name": "1.0 Measurements and Their Errors",
            "open": false,
            "children": []
          },
          {
            "name": "1.1 Particles",
            "open": false,
            "children": []
          },
          {
            "name": "1.2 Electromagnetic Radiation & Quantum Phenomena",
            "open": false,
            "children": []
          },
          {
            "name": "1.3 Waves",
            "open": false,
            "children": [
              {
                "name": "Progressive And Stationary Waves",
                "open": false,
                "children": []
              },
              {
                "name": "Refraction, Diffraction And Interference",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "1.4 Mechanics",
            "open": false,
            "children": []
          },
          {
            "name": "1.5 Materials",
            "open": false,
            "children": []
          },
          {
            "name": "1.6 Electricity",
            "open": false,
            "children": [
              {
                "name": "Alternating Currents",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "1.7 Further Mechanics",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "2.0 Paper 2",
        "open": false,
        "children": [
          {
            "name": "2.1 Thermal Physics",
            "open": false,
            "children": []
          },
          {
            "name": "2.2 Fields",
            "open": false,
            "children": [
              {
                "name": "Electric Fields And Capacitors",
                "open": false,
                "children": []
              },
              {
                "name": "Gravitational Fields",
                "open": false,
                "children": []
              },
              {
                "name": "Magnetic Fields",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "2.3 Nuclear Physics",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "3.0 Paper 3",
        "open": false,
        "children": [
          {
            "name": "3.1 Practical Skills",
            "open": false,
            "children": [
              {
                "name": "Core Practical Skills & Data Analysis",
                "open": false,
                "children": []
              },
              {
                "name": "Required Practicals",
                "open": false,
                "children": [
                  {
                    "name": "RP01 Stationary Waves",
                    "open": false,
                    "children": []
                  },
                  {
                    "name": "RP02 Interference",
                    "open": false,
                    "children": []
                  },
                  {
                    "name": "RP03 Determining g",
                    "open": false,
                    "children": []
                  },
                  {
                    "name": "RP04 Young Modulus",
                    "open": false,
                    "children": []
                  },
                  {
                    "name": "RP05 Resistivity",
                    "open": false,
                    "children": []
                  },
                  {
                    "name": "RP06 Internal Resistance and emf",
                    "open": false,
                    "children": []
                  },
                  {
                    "name": "RP07 Simple Harmonic Motion",
                    "open": false,
                    "children": []
                  },
                  {
                    "name": "RP08 Gas Laws",
                    "open": false,
                    "children": []
                  },
                  {
                    "name": "RP09 Capacitor Charging and Discharging",
                    "open": false,
                    "children": []
                  },
                  {
                    "name": "RP10 Magnetic Force on a Wire",
                    "open": false,
                    "children": []
                  },
                  {
                    "name": "RP11 Magnetic Flux Linkage",
                    "open": false,
                    "children": []
                  },
                  {
                    "name": "RP12 Inverse Square Law",
                    "open": false,
                    "children": []
                  }
                ]
              }
            ]
          },
          {
            "name": "3.2 Astrophysics",
            "open": false,
            "children": [
              {
                "name": "12.1 Diffraction & Resolution",
                "open": false,
                "children": []
              },
              {
                "name": "12.2 Stars & Spectra",
                "open": false,
                "children": []
              },
              {
                "name": "12.3 Telescopes & Optics",
                "open": false,
                "children": []
              },
              {
                "name": "12.4 Cosmology & Big Bang",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "3.3 Medical Physics",
            "open": false,
            "children": [
              {
                "name": "10.1 Physics of the Eye",
                "open": false,
                "children": []
              },
              {
                "name": "10.2 Physics of the Ear",
                "open": false,
                "children": []
              },
              {
                "name": "10.3 Biological Measurement & Non-ionising Imaging",
                "open": false,
                "children": []
              },
              {
                "name": "10.5 X-ray Imaging",
                "open": false,
                "children": []
              },
              {
                "name": "10.6 Radionuclide Imaging & Therapy",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "3.4 Engineering Physics",
            "open": false,
            "children": [
              {
                "name": "11.1 Rotational Dynamics",
                "open": false,
                "children": []
              },
              {
                "name": "11.2 Thermodynamics & Engines",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "3.5 Turning Points in Physics",
            "open": false,
            "children": [
              {
                "name": "12.1 Discovery of the Electron",
                "open": false,
                "children": []
              },
              {
                "name": "12.2 Wave–Particle Duality",
                "open": false,
                "children": []
              },
              {
                "name": "12.3 Special Relativity",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "3.6 Electronics",
            "open": false,
            "children": [
              {
                "name": "13.1 Discrete Semiconductor Devices",
                "open": false,
                "children": []
              },
              {
                "name": "13.2 Analogue & Digital Signals",
                "open": false,
                "children": []
              },
              {
                "name": "13.3 Analogue Signal Processing",
                "open": false,
                "children": []
              },
              {
                "name": "13.4 Operational Amplifier",
                "open": false,
                "children": []
              },
              {
                "name": "13.5 Digital Signal Processing",
                "open": false,
                "children": []
              },
              {
                "name": "13.6 Data Communication Systems",
                "open": false,
                "children": []
              }
            ]
          }
        ]
      }
    ],
    "deckCount": 61
  },
  "AQA A-Level Biology 7402": {
    "root": "AQA A-Level Biology 7402",
    "open": true,
    "papers": [
      {
        "name": "01 Biological Molecules",
        "open": false,
        "children": [
          {
            "name": "01 Monomers and Polymers",
            "open": false,
            "children": []
          },
          {
            "name": "02 Carbohydrates",
            "open": false,
            "children": []
          },
          {
            "name": "03 Lipids",
            "open": false,
            "children": []
          },
          {
            "name": "04 Protein Structure",
            "open": false,
            "children": []
          },
          {
            "name": "05 Enzymes",
            "open": false,
            "children": []
          },
          {
            "name": "06 DNA and RNA Structure",
            "open": false,
            "children": []
          },
          {
            "name": "07 DNA Replication",
            "open": false,
            "children": []
          },
          {
            "name": "08 ATP",
            "open": false,
            "children": []
          },
          {
            "name": "09 Water",
            "open": false,
            "children": []
          },
          {
            "name": "10 Inorganic Ions",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "02 Cells",
        "open": false,
        "children": [
          {
            "name": "01 Eukaryotic Cells",
            "open": false,
            "children": []
          },
          {
            "name": "02 Prokaryotic Cells and Viruses",
            "open": false,
            "children": []
          },
          {
            "name": "03 Microscopy and Cell Fractionation",
            "open": false,
            "children": []
          },
          {
            "name": "04 Cell Division",
            "open": false,
            "children": []
          },
          {
            "name": "05 Membrane Transport",
            "open": false,
            "children": []
          },
          {
            "name": "06 Cell Recognition and Immunity",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "03 Organisms Exchange Substances with Their Environment",
        "open": false,
        "children": [
          {
            "name": "01 Surface Area to Volume Ratio",
            "open": false,
            "children": []
          },
          {
            "name": "02 Gas Exchange",
            "open": false,
            "children": []
          },
          {
            "name": "03 Digestion and Absorption",
            "open": false,
            "children": []
          },
          {
            "name": "04 Mass Transport in Animals",
            "open": false,
            "children": []
          },
          {
            "name": "05 Mass Transport in Plants",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "04 Genetic Information, Variation and Relationships",
        "open": false,
        "children": [
          {
            "name": "01 DNA, Genes and Chromosomes",
            "open": false,
            "children": []
          },
          {
            "name": "02 Protein Synthesis",
            "open": false,
            "children": []
          },
          {
            "name": "03 Mutation, Meiosis and Genetic Variation",
            "open": false,
            "children": []
          },
          {
            "name": "04 Adaptation",
            "open": false,
            "children": []
          },
          {
            "name": "05 Species and Taxonomy",
            "open": false,
            "children": []
          },
          {
            "name": "06 Biodiversity",
            "open": false,
            "children": []
          },
          {
            "name": "07 Investigating Diversity",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "05 Energy Transfers In and Between Organisms",
        "open": false,
        "children": [
          {
            "name": "01 Photosynthesis",
            "open": false,
            "children": []
          },
          {
            "name": "02 Respiration",
            "open": false,
            "children": []
          },
          {
            "name": "03 Energy and Ecosystems",
            "open": false,
            "children": []
          },
          {
            "name": "04 Nutrient Cycles",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "06 Responses and Homeostasis",
        "open": false,
        "children": [
          {
            "name": "01 Survival and Response",
            "open": false,
            "children": []
          },
          {
            "name": "02 Receptors",
            "open": false,
            "children": []
          },
          {
            "name": "03 Control of Heart Rate",
            "open": false,
            "children": []
          },
          {
            "name": "04 Nerve Impulses",
            "open": false,
            "children": []
          },
          {
            "name": "05 Synaptic Transmission",
            "open": false,
            "children": []
          },
          {
            "name": "06 Skeletal Muscles",
            "open": false,
            "children": []
          },
          {
            "name": "07 Homeostasis and Negative Feedback",
            "open": false,
            "children": []
          },
          {
            "name": "08 Control of Blood Glucose",
            "open": false,
            "children": []
          },
          {
            "name": "09 Control of Blood Water Potential",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "07 Genetics, Populations, Evolution and Ecosystems",
        "open": false,
        "children": [
          {
            "name": "01 Inheritance",
            "open": false,
            "children": []
          },
          {
            "name": "02 Populations",
            "open": false,
            "children": []
          },
          {
            "name": "03 Evolution and Speciation",
            "open": false,
            "children": []
          },
          {
            "name": "04 Populations in Ecosystems",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "08 The Control of Gene Expression",
        "open": false,
        "children": [
          {
            "name": "01 Mutations and Polypeptide Structure",
            "open": false,
            "children": []
          },
          {
            "name": "02 Non-coding DNA",
            "open": false,
            "children": []
          },
          {
            "name": "03 Regulation of Gene Expression",
            "open": false,
            "children": []
          },
          {
            "name": "04 Gene Expression and Cancer",
            "open": false,
            "children": []
          },
          {
            "name": "05 Genome Projects and Proteomics",
            "open": false,
            "children": []
          },
          {
            "name": "06 Recombinant DNA Technology",
            "open": false,
            "children": []
          },
          {
            "name": "07 DNA Probes, Screening and Personalised Medicine",
            "open": false,
            "children": []
          },
          {
            "name": "08 Genetic Fingerprinting",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "09 Paper 3 Synoptic Essays",
        "open": false,
        "children": []
      },
      {
        "name": "10 Practical and Mathematical Skills",
        "open": false,
        "children": []
      },
      {
        "name": "11 Required Practicals",
        "open": false,
        "children": [
          {
            "name": "01 Enzyme reaction rates",
            "open": false,
            "children": []
          },
          {
            "name": "02 Root-tip squash and mitotic index",
            "open": false,
            "children": []
          },
          {
            "name": "03 Plant-tissue water potential",
            "open": false,
            "children": []
          },
          {
            "name": "04 Cell-surface membrane permeability",
            "open": false,
            "children": []
          },
          {
            "name": "05 Exchange or mass-transport dissection",
            "open": false,
            "children": []
          },
          {
            "name": "06 Aseptic technique and antimicrobials",
            "open": false,
            "children": []
          },
          {
            "name": "07 Chromatography of leaf pigments",
            "open": false,
            "children": []
          },
          {
            "name": "08 Dehydrogenase activity in chloroplasts",
            "open": false,
            "children": []
          },
          {
            "name": "09 Respiration rate",
            "open": false,
            "children": []
          },
          {
            "name": "10 Animal movement and environmental variables",
            "open": false,
            "children": []
          },
          {
            "name": "11 Glucose calibration curve and colorimetry",
            "open": false,
            "children": []
          },
          {
            "name": "12 Species distribution",
            "open": false,
            "children": []
          }
        ]
      }
    ],
    "deckCount": 77
  },
  "AQA A-Level Chemistry 7405": {
    "root": "AQA A-Level Chemistry 7405",
    "open": true,
    "papers": [
      {
        "name": "01 Physical Chemistry",
        "open": false,
        "children": [
          {
            "name": "01 Atomic Structure",
            "open": false,
            "children": []
          },
          {
            "name": "02 Amount of Substance",
            "open": false,
            "children": []
          },
          {
            "name": "03 Bonding",
            "open": false,
            "children": []
          },
          {
            "name": "04 Energetics",
            "open": false,
            "children": []
          },
          {
            "name": "05 Kinetics",
            "open": false,
            "children": []
          },
          {
            "name": "06 Chemical Equilibria and Kc",
            "open": false,
            "children": []
          },
          {
            "name": "07 Oxidation, Reduction and Redox Equations",
            "open": false,
            "children": []
          },
          {
            "name": "08 Thermodynamics",
            "open": false,
            "children": []
          },
          {
            "name": "09 Rate Equations",
            "open": false,
            "children": []
          },
          {
            "name": "10 Equilibrium Constant Kp",
            "open": false,
            "children": []
          },
          {
            "name": "11 Electrode Potentials and Electrochemical Cells",
            "open": false,
            "children": []
          },
          {
            "name": "12 Acids and Bases",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "02 Inorganic Chemistry",
        "open": false,
        "children": [
          {
            "name": "01 Periodicity",
            "open": false,
            "children": []
          },
          {
            "name": "02 Group 2: The Alkaline Earth Metals",
            "open": false,
            "children": []
          },
          {
            "name": "03 Group 7(17): The Halogens",
            "open": false,
            "children": []
          },
          {
            "name": "04 Properties of Period 3 Elements and Their Oxides",
            "open": false,
            "children": []
          },
          {
            "name": "05 Transition Metals",
            "open": false,
            "children": []
          },
          {
            "name": "06 Reactions of Ions in Aqueous Solution",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "03 Organic Chemistry",
        "open": false,
        "children": [
          {
            "name": "01 Introduction to Organic Chemistry",
            "open": false,
            "children": []
          },
          {
            "name": "02 Alkanes",
            "open": false,
            "children": []
          },
          {
            "name": "03 Halogenoalkanes",
            "open": false,
            "children": []
          },
          {
            "name": "04 Alkenes",
            "open": false,
            "children": []
          },
          {
            "name": "05 Alcohols",
            "open": false,
            "children": []
          },
          {
            "name": "06 Organic Analysis",
            "open": false,
            "children": []
          },
          {
            "name": "07 Optical Isomerism",
            "open": false,
            "children": []
          },
          {
            "name": "08 Aldehydes and Ketones",
            "open": false,
            "children": []
          },
          {
            "name": "09 Carboxylic Acids and Derivatives",
            "open": false,
            "children": []
          },
          {
            "name": "10 Aromatic Chemistry",
            "open": false,
            "children": []
          },
          {
            "name": "11 Amines",
            "open": false,
            "children": []
          },
          {
            "name": "12 Polymers",
            "open": false,
            "children": []
          },
          {
            "name": "13 Amino Acids, Proteins and DNA",
            "open": false,
            "children": []
          },
          {
            "name": "14 Organic Synthesis",
            "open": false,
            "children": []
          },
          {
            "name": "15 Nuclear Magnetic Resonance Spectroscopy",
            "open": false,
            "children": []
          },
          {
            "name": "16 Chromatography",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "04 Required Practicals and Experimental Skills",
        "open": false,
        "children": [
          {
            "name": "00 General Practical Skills, Measurements and Data",
            "open": false,
            "children": []
          },
          {
            "name": "01 Required Practical 1: Volumetric Solution and Acid-Base Titration",
            "open": false,
            "children": []
          },
          {
            "name": "02 Required Practical 2: Measurement of an Enthalpy Change",
            "open": false,
            "children": []
          },
          {
            "name": "03 Required Practical 3: Effect of Temperature on Reaction Rate",
            "open": false,
            "children": []
          },
          {
            "name": "04 Required Practical 4: Identification of Cations and Anions",
            "open": false,
            "children": []
          },
          {
            "name": "05 Required Practical 5: Distillation of a Reaction Product",
            "open": false,
            "children": []
          },
          {
            "name": "06 Required Practical 6: Tests for Organic Functional Groups",
            "open": false,
            "children": []
          },
          {
            "name": "07 Required Practical 7: Initial-Rate and Continuous-Monitoring Methods",
            "open": false,
            "children": []
          },
          {
            "name": "08 Required Practical 8: EMF of an Electrochemical Cell",
            "open": false,
            "children": []
          },
          {
            "name": "09 Required Practical 9: pH Curves for Weak-Strong Titrations",
            "open": false,
            "children": []
          },
          {
            "name": "10 Required Practical 10: Preparation and Purification of Organic Products",
            "open": false,
            "children": []
          },
          {
            "name": "11 Required Practical 11: Identification of Transition-Metal Ions",
            "open": false,
            "children": []
          },
          {
            "name": "12 Required Practical 12: Thin-Layer Chromatography",
            "open": false,
            "children": []
          },
          {
            "name": "13 Unfamiliar Practical Contexts and Evaluation",
            "open": false,
            "children": []
          }
        ]
      }
    ],
    "deckCount": 53
  },
  "AQA GCSE Biology (8461)": {
    "root": "AQA GCSE Biology (8461)",
    "open": true,
    "papers": [
      {
        "name": "01 Cell biology",
        "open": false,
        "children": [
          {
            "name": "1.01 Eukaryotes and prokaryotes",
            "open": false,
            "children": []
          },
          {
            "name": "1.02 Animal and plant cells",
            "open": false,
            "children": []
          },
          {
            "name": "1.03 Cell specialisation",
            "open": false,
            "children": []
          },
          {
            "name": "1.04 Cell differentiation",
            "open": false,
            "children": []
          },
          {
            "name": "1.05 Microscopy",
            "open": false,
            "children": []
          },
          {
            "name": "1.06 Culturing microorganisms",
            "open": false,
            "children": []
          },
          {
            "name": "1.07 Chromosomes",
            "open": false,
            "children": []
          },
          {
            "name": "1.08 Mitosis and the cell cycle",
            "open": false,
            "children": []
          },
          {
            "name": "1.09 Stem cells",
            "open": false,
            "children": []
          },
          {
            "name": "1.10 Diffusion",
            "open": false,
            "children": []
          },
          {
            "name": "1.11 Osmosis",
            "open": false,
            "children": []
          },
          {
            "name": "1.12 Active transport",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "02 Organisation",
        "open": false,
        "children": [
          {
            "name": "2.01 Principles of organisation",
            "open": false,
            "children": []
          },
          {
            "name": "2.02 The human digestive system",
            "open": false,
            "children": []
          },
          {
            "name": "2.03 The heart and blood vessels",
            "open": false,
            "children": []
          },
          {
            "name": "2.04 Blood",
            "open": false,
            "children": []
          },
          {
            "name": "2.05 Coronary heart disease",
            "open": false,
            "children": []
          },
          {
            "name": "2.06 Health issues",
            "open": false,
            "children": []
          },
          {
            "name": "2.07 Lifestyle and non-communicable disease",
            "open": false,
            "children": []
          },
          {
            "name": "2.08 Cancer",
            "open": false,
            "children": []
          },
          {
            "name": "2.09 Plant tissues",
            "open": false,
            "children": []
          },
          {
            "name": "2.10 Plant organ systems",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "03 Infection and response",
        "open": false,
        "children": [
          {
            "name": "3.01 Communicable diseases",
            "open": false,
            "children": []
          },
          {
            "name": "3.02 Viral diseases",
            "open": false,
            "children": []
          },
          {
            "name": "3.03 Bacterial diseases",
            "open": false,
            "children": []
          },
          {
            "name": "3.04 Fungal diseases",
            "open": false,
            "children": []
          },
          {
            "name": "3.05 Protist diseases",
            "open": false,
            "children": []
          },
          {
            "name": "3.06 Human defence systems",
            "open": false,
            "children": []
          },
          {
            "name": "3.07 Vaccination",
            "open": false,
            "children": []
          },
          {
            "name": "3.08 Antibiotics and painkillers",
            "open": false,
            "children": []
          },
          {
            "name": "3.09 Discovery and development of drugs",
            "open": false,
            "children": []
          },
          {
            "name": "3.10 Producing monoclonal antibodies",
            "open": false,
            "children": []
          },
          {
            "name": "3.11 Uses of monoclonal antibodies",
            "open": false,
            "children": []
          },
          {
            "name": "3.12 Detection and identification of plant diseases",
            "open": false,
            "children": []
          },
          {
            "name": "3.13 Plant defence responses",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "04 Bioenergetics",
        "open": false,
        "children": [
          {
            "name": "4.01 Photosynthetic reaction",
            "open": false,
            "children": []
          },
          {
            "name": "4.02 Rate of photosynthesis",
            "open": false,
            "children": []
          },
          {
            "name": "4.03 Uses of glucose from photosynthesis",
            "open": false,
            "children": []
          },
          {
            "name": "4.04 Aerobic and anaerobic respiration",
            "open": false,
            "children": []
          },
          {
            "name": "4.05 Response to exercise",
            "open": false,
            "children": []
          },
          {
            "name": "4.06 Metabolism",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "05 Homeostasis and response",
        "open": false,
        "children": [
          {
            "name": "5.01 Homeostasis",
            "open": false,
            "children": []
          },
          {
            "name": "5.02 Human nervous system",
            "open": false,
            "children": []
          },
          {
            "name": "5.03 The brain",
            "open": false,
            "children": []
          },
          {
            "name": "5.04 The eye",
            "open": false,
            "children": []
          },
          {
            "name": "5.05 Control of body temperature",
            "open": false,
            "children": []
          },
          {
            "name": "5.06 Human endocrine system",
            "open": false,
            "children": []
          },
          {
            "name": "5.07 Control of blood glucose",
            "open": false,
            "children": []
          },
          {
            "name": "5.08 Water and nitrogen balance",
            "open": false,
            "children": []
          },
          {
            "name": "5.09 Hormones in human reproduction",
            "open": false,
            "children": []
          },
          {
            "name": "5.10 Contraception",
            "open": false,
            "children": []
          },
          {
            "name": "5.11 Hormones to treat infertility",
            "open": false,
            "children": []
          },
          {
            "name": "5.12 Negative feedback",
            "open": false,
            "children": []
          },
          {
            "name": "5.13 Plant control and coordination",
            "open": false,
            "children": []
          },
          {
            "name": "5.14 Uses of plant hormones",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "06 Inheritance, variation and evolution",
        "open": false,
        "children": [
          {
            "name": "6.01 Sexual and asexual reproduction",
            "open": false,
            "children": []
          },
          {
            "name": "6.02 Meiosis",
            "open": false,
            "children": []
          },
          {
            "name": "6.03 Advantages and disadvantages of reproduction modes",
            "open": false,
            "children": []
          },
          {
            "name": "6.04 DNA and the genome",
            "open": false,
            "children": []
          },
          {
            "name": "6.05 DNA structure",
            "open": false,
            "children": []
          },
          {
            "name": "6.06 Genetic inheritance",
            "open": false,
            "children": []
          },
          {
            "name": "6.07 Inherited disorders",
            "open": false,
            "children": []
          },
          {
            "name": "6.08 Sex determination",
            "open": false,
            "children": []
          },
          {
            "name": "6.09 Variation",
            "open": false,
            "children": []
          },
          {
            "name": "6.10 Evolution",
            "open": false,
            "children": []
          },
          {
            "name": "6.11 Selective breeding",
            "open": false,
            "children": []
          },
          {
            "name": "6.12 Genetic engineering",
            "open": false,
            "children": []
          },
          {
            "name": "6.13 Cloning",
            "open": false,
            "children": []
          },
          {
            "name": "6.14 Theory of evolution",
            "open": false,
            "children": []
          },
          {
            "name": "6.15 Speciation",
            "open": false,
            "children": []
          },
          {
            "name": "6.16 Understanding genetics",
            "open": false,
            "children": []
          },
          {
            "name": "6.17 Evidence for evolution",
            "open": false,
            "children": []
          },
          {
            "name": "6.18 Fossils",
            "open": false,
            "children": []
          },
          {
            "name": "6.19 Extinction",
            "open": false,
            "children": []
          },
          {
            "name": "6.20 Antibiotic-resistant bacteria",
            "open": false,
            "children": []
          },
          {
            "name": "6.21 Classification of living organisms",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "07 Ecology",
        "open": false,
        "children": [
          {
            "name": "7.01 Communities",
            "open": false,
            "children": []
          },
          {
            "name": "7.02 Abiotic factors",
            "open": false,
            "children": []
          },
          {
            "name": "7.03 Biotic factors",
            "open": false,
            "children": []
          },
          {
            "name": "7.04 Adaptations",
            "open": false,
            "children": []
          },
          {
            "name": "7.05 Levels of organisation in ecosystems",
            "open": false,
            "children": []
          },
          {
            "name": "7.06 How materials are cycled",
            "open": false,
            "children": []
          },
          {
            "name": "7.07 Decomposition",
            "open": false,
            "children": []
          },
          {
            "name": "7.08 Impact of environmental change",
            "open": false,
            "children": []
          },
          {
            "name": "7.09 Biodiversity",
            "open": false,
            "children": []
          },
          {
            "name": "7.10 Waste management",
            "open": false,
            "children": []
          },
          {
            "name": "7.11 Land use",
            "open": false,
            "children": []
          },
          {
            "name": "7.12 Deforestation",
            "open": false,
            "children": []
          },
          {
            "name": "7.13 Global warming",
            "open": false,
            "children": []
          },
          {
            "name": "7.14 Maintaining biodiversity",
            "open": false,
            "children": []
          },
          {
            "name": "7.15 Trophic levels",
            "open": false,
            "children": []
          },
          {
            "name": "7.16 Pyramids of biomass",
            "open": false,
            "children": []
          },
          {
            "name": "7.17 Transfer of biomass",
            "open": false,
            "children": []
          },
          {
            "name": "7.18 Factors affecting food security",
            "open": false,
            "children": []
          },
          {
            "name": "7.19 Farming techniques",
            "open": false,
            "children": []
          },
          {
            "name": "7.20 Sustainable fisheries",
            "open": false,
            "children": []
          },
          {
            "name": "7.21 Role of biotechnology",
            "open": false,
            "children": []
          }
        ]
      }
    ],
    "deckCount": 105
  },
  "AQA GCSE Chemistry 8462": {
    "root": "AQA GCSE Chemistry 8462",
    "open": true,
    "papers": [
      {
        "name": "01 Paper 1 - Topics 1-5",
        "open": false,
        "children": [
          {
            "name": "01 Atomic structure and the periodic table",
            "open": false,
            "children": [
              {
                "name": "01 A simple model of the atom",
                "open": false,
                "children": []
              },
              {
                "name": "02 The periodic table",
                "open": false,
                "children": []
              },
              {
                "name": "03 Transition metals",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "02 Bonding, structure and properties",
            "open": false,
            "children": [
              {
                "name": "01 Chemical bonds",
                "open": false,
                "children": []
              },
              {
                "name": "02 Bonding and material properties",
                "open": false,
                "children": []
              },
              {
                "name": "03 Carbon structures",
                "open": false,
                "children": []
              },
              {
                "name": "04 Nanoparticles",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "03 Quantitative chemistry",
            "open": false,
            "children": [
              {
                "name": "01 Measurements, conservation and equations",
                "open": false,
                "children": []
              },
              {
                "name": "02 Amount of substance and reacting masses",
                "open": false,
                "children": []
              },
              {
                "name": "03 Yield and atom economy",
                "open": false,
                "children": []
              },
              {
                "name": "04 Concentrations in mol/dm3",
                "open": false,
                "children": []
              },
              {
                "name": "05 Volumes of gases",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "04 Chemical changes",
            "open": false,
            "children": [
              {
                "name": "01 Reactivity of metals",
                "open": false,
                "children": []
              },
              {
                "name": "02 Acids, salts and titration",
                "open": false,
                "children": []
              },
              {
                "name": "03 Electrolysis",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "05 Energy changes",
            "open": false,
            "children": [
              {
                "name": "01 Exothermic and endothermic reactions",
                "open": false,
                "children": []
              },
              {
                "name": "02 Cells and fuel cells",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "06 Required Practicals - Paper 1",
            "open": false,
            "children": [
              {
                "name": "RP1 Preparing a pure, dry soluble salt",
                "open": false,
                "children": []
              },
              {
                "name": "RP2 Titration",
                "open": false,
                "children": []
              },
              {
                "name": "RP3 Electrolysis of aqueous solutions",
                "open": false,
                "children": []
              },
              {
                "name": "RP4 Temperature changes",
                "open": false,
                "children": []
              }
            ]
          }
        ]
      },
      {
        "name": "02 Paper 2 - Topics 6-10",
        "open": false,
        "children": [
          {
            "name": "06 Rate and extent of chemical change",
            "open": false,
            "children": [
              {
                "name": "01 Rates of reaction",
                "open": false,
                "children": []
              },
              {
                "name": "02 Reversible reactions and equilibrium",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "07 Organic chemistry",
            "open": false,
            "children": [
              {
                "name": "01 Crude oil and hydrocarbons",
                "open": false,
                "children": []
              },
              {
                "name": "02 Alkenes, alcohols and carboxylic acids",
                "open": false,
                "children": []
              },
              {
                "name": "03 Synthetic and natural polymers",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "08 Chemical analysis",
            "open": false,
            "children": [
              {
                "name": "01 Purity, formulations and chromatography",
                "open": false,
                "children": []
              },
              {
                "name": "02 Identification of gases",
                "open": false,
                "children": []
              },
              {
                "name": "03 Identification of ions and instrumental methods",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "09 Chemistry of the atmosphere",
            "open": false,
            "children": [
              {
                "name": "01 Evolution of the atmosphere",
                "open": false,
                "children": []
              },
              {
                "name": "02 Greenhouse gases and climate change",
                "open": false,
                "children": []
              },
              {
                "name": "03 Atmospheric pollutants",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "10 Using resources",
            "open": false,
            "children": [
              {
                "name": "01 Resources and potable water",
                "open": false,
                "children": []
              },
              {
                "name": "02 Life-cycle assessment and recycling",
                "open": false,
                "children": []
              },
              {
                "name": "03 Using materials",
                "open": false,
                "children": []
              },
              {
                "name": "04 Haber process and NPK fertilisers",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "11 Required Practicals - Paper 2",
            "open": false,
            "children": [
              {
                "name": "RP5 Rates of reaction",
                "open": false,
                "children": []
              },
              {
                "name": "RP6 Paper chromatography",
                "open": false,
                "children": []
              },
              {
                "name": "RP7 Identifying ions",
                "open": false,
                "children": []
              },
              {
                "name": "RP8 Water analysis and purification",
                "open": false,
                "children": []
              }
            ]
          }
        ]
      },
      {
        "name": "03 Both Papers - Working scientifically, maths and synoptic skills",
        "open": false,
        "children": [
          {
            "name": "01 Planning and evaluating investigations",
            "open": false,
            "children": []
          },
          {
            "name": "02 Data, graphs and chemical calculations",
            "open": false,
            "children": []
          },
          {
            "name": "03 Unfamiliar and cross-topic questions",
            "open": false,
            "children": []
          }
        ]
      }
    ],
    "deckCount": 59
  },
  "Cambridge IGCSE Biology (0610)": {
    "root": "Cambridge IGCSE Biology (0610)",
    "open": true,
    "papers": [
      {
        "name": "01 Characteristics and classification of living organisms",
        "open": false,
        "children": [
          {
            "name": "1.1 Characteristics of living organisms",
            "open": false,
            "children": []
          },
          {
            "name": "1.2 Concept and uses of classification systems",
            "open": false,
            "children": []
          },
          {
            "name": "1.3 Features of organisms",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "02 Organisation of the organism",
        "open": false,
        "children": [
          {
            "name": "2.1 Cell structure",
            "open": false,
            "children": []
          },
          {
            "name": "2.2 Size of specimens",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "03 Movement into and out of cells",
        "open": false,
        "children": [
          {
            "name": "3.1 Diffusion",
            "open": false,
            "children": []
          },
          {
            "name": "3.2 Osmosis",
            "open": false,
            "children": []
          },
          {
            "name": "3.3 Active transport",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "04 Biological molecules",
        "open": false,
        "children": [
          {
            "name": "4.1 Biological molecules",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "05 Enzymes",
        "open": false,
        "children": [
          {
            "name": "5.1 Enzymes",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "06 Plant nutrition",
        "open": false,
        "children": [
          {
            "name": "6.1 Photosynthesis",
            "open": false,
            "children": []
          },
          {
            "name": "6.2 Leaf structure",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "07 Human nutrition",
        "open": false,
        "children": [
          {
            "name": "7.1 Diet",
            "open": false,
            "children": []
          },
          {
            "name": "7.2 Digestive system",
            "open": false,
            "children": []
          },
          {
            "name": "7.3 Physical digestion",
            "open": false,
            "children": []
          },
          {
            "name": "7.4 Chemical digestion",
            "open": false,
            "children": []
          },
          {
            "name": "7.5 Absorption",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "08 Transport in plants",
        "open": false,
        "children": [
          {
            "name": "8.1 Xylem and phloem",
            "open": false,
            "children": []
          },
          {
            "name": "8.2 Water uptake",
            "open": false,
            "children": []
          },
          {
            "name": "8.3 Transpiration",
            "open": false,
            "children": []
          },
          {
            "name": "8.4 Translocation",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "09 Transport in animals",
        "open": false,
        "children": [
          {
            "name": "9.1 Circulatory systems",
            "open": false,
            "children": []
          },
          {
            "name": "9.2 Heart",
            "open": false,
            "children": []
          },
          {
            "name": "9.3 Blood vessels",
            "open": false,
            "children": []
          },
          {
            "name": "9.4 Blood",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "10 Diseases and immunity",
        "open": false,
        "children": [
          {
            "name": "10.1 Diseases and immunity",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "11 Gas exchange in humans",
        "open": false,
        "children": [
          {
            "name": "11.1 Gas exchange in humans",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "12 Respiration",
        "open": false,
        "children": [
          {
            "name": "12.1 Respiration",
            "open": false,
            "children": []
          },
          {
            "name": "12.2 Aerobic respiration",
            "open": false,
            "children": []
          },
          {
            "name": "12.3 Anaerobic respiration",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "13 Excretion in humans",
        "open": false,
        "children": [
          {
            "name": "13.1 Excretion in humans",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "14 Coordination and response",
        "open": false,
        "children": [
          {
            "name": "14.1 Coordination and response",
            "open": false,
            "children": []
          },
          {
            "name": "14.2 Sense organs",
            "open": false,
            "children": []
          },
          {
            "name": "14.3 Hormones",
            "open": false,
            "children": []
          },
          {
            "name": "14.4 Homeostasis",
            "open": false,
            "children": []
          },
          {
            "name": "14.5 Tropic responses",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "15 Drugs",
        "open": false,
        "children": [
          {
            "name": "15.1 Drugs",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "16 Reproduction",
        "open": false,
        "children": [
          {
            "name": "16.1 Asexual reproduction",
            "open": false,
            "children": []
          },
          {
            "name": "16.2 Sexual reproduction",
            "open": false,
            "children": []
          },
          {
            "name": "16.3 Sexual reproduction in plants",
            "open": false,
            "children": []
          },
          {
            "name": "16.4 Sexual reproduction in humans",
            "open": false,
            "children": []
          },
          {
            "name": "16.5 Sex hormones in humans",
            "open": false,
            "children": []
          },
          {
            "name": "16.6 Sexually transmitted infections",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "17 Inheritance",
        "open": false,
        "children": [
          {
            "name": "17.1 Chromosomes, genes and proteins",
            "open": false,
            "children": []
          },
          {
            "name": "17.2 Mitosis",
            "open": false,
            "children": []
          },
          {
            "name": "17.3 Meiosis",
            "open": false,
            "children": []
          },
          {
            "name": "17.4 Monohybrid inheritance",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "18 Variation and selection",
        "open": false,
        "children": [
          {
            "name": "18.1 Variation",
            "open": false,
            "children": []
          },
          {
            "name": "18.2 Adaptive features",
            "open": false,
            "children": []
          },
          {
            "name": "18.3 Selection",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "19 Organisms and their environment",
        "open": false,
        "children": [
          {
            "name": "19.1 Energy flow",
            "open": false,
            "children": []
          },
          {
            "name": "19.2 Food chains and food webs",
            "open": false,
            "children": []
          },
          {
            "name": "19.3 Nutrient cycles",
            "open": false,
            "children": []
          },
          {
            "name": "19.4 Populations",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "20 Human influences on ecosystems",
        "open": false,
        "children": [
          {
            "name": "20.1 Food supply",
            "open": false,
            "children": []
          },
          {
            "name": "20.2 Habitat destruction",
            "open": false,
            "children": []
          },
          {
            "name": "20.3 Pollution",
            "open": false,
            "children": []
          },
          {
            "name": "20.4 Conservation",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "21 Biotechnology and genetic modification",
        "open": false,
        "children": [
          {
            "name": "21.1 Biotechnology and genetic modification",
            "open": false,
            "children": []
          },
          {
            "name": "21.2 Biotechnology",
            "open": false,
            "children": []
          },
          {
            "name": "21.3 Genetic modification",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "22 Practical and data skills",
        "open": false,
        "children": [
          {
            "name": "01 Microscopy and biological drawing",
            "open": false,
            "children": []
          },
          {
            "name": "02 Food tests",
            "open": false,
            "children": []
          },
          {
            "name": "03 Diffusion",
            "open": false,
            "children": []
          },
          {
            "name": "04 Osmosis using dialysis tubing",
            "open": false,
            "children": []
          },
          {
            "name": "05 Osmosis in plant tissue",
            "open": false,
            "children": []
          },
          {
            "name": "06 Enzyme rate",
            "open": false,
            "children": []
          },
          {
            "name": "07 Photosynthesis",
            "open": false,
            "children": []
          },
          {
            "name": "08 Transpiration",
            "open": false,
            "children": []
          },
          {
            "name": "09 Human responses",
            "open": false,
            "children": []
          },
          {
            "name": "10 Respiration",
            "open": false,
            "children": []
          },
          {
            "name": "11 Seed germination",
            "open": false,
            "children": []
          },
          {
            "name": "12 Plant responses",
            "open": false,
            "children": []
          },
          {
            "name": "13 Ecological sampling",
            "open": false,
            "children": []
          },
          {
            "name": "14 Microorganism growth or biotechnology",
            "open": false,
            "children": []
          }
        ]
      }
    ],
    "deckCount": 98
  },
  "Cambridge IGCSE Chemistry 0620": {
    "root": "Cambridge IGCSE Chemistry 0620",
    "open": true,
    "papers": [
      {
        "name": "01 States of matter",
        "open": false,
        "children": [
          {
            "name": "1.1 Solids, liquids and gases",
            "open": false,
            "children": []
          },
          {
            "name": "1.2 Diffusion",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "02 Atoms, elements and compounds",
        "open": false,
        "children": [
          {
            "name": "2.1 Elements, compounds and mixtures",
            "open": false,
            "children": []
          },
          {
            "name": "2.2 Atomic structure and the Periodic Table",
            "open": false,
            "children": []
          },
          {
            "name": "2.3 Isotopes",
            "open": false,
            "children": []
          },
          {
            "name": "2.4 Ions and ionic bonds",
            "open": false,
            "children": []
          },
          {
            "name": "2.5 Simple molecules and covalent bonds",
            "open": false,
            "children": []
          },
          {
            "name": "2.6 Giant covalent structures",
            "open": false,
            "children": []
          },
          {
            "name": "2.7 Metallic bonding",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "03 Stoichiometry",
        "open": false,
        "children": [
          {
            "name": "3.1 Formulae and equations",
            "open": false,
            "children": []
          },
          {
            "name": "3.2 Relative masses",
            "open": false,
            "children": []
          },
          {
            "name": "3.3 The mole and the Avogadro constant",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "04 Electrochemistry",
        "open": false,
        "children": [
          {
            "name": "4.1 Electrolysis",
            "open": false,
            "children": []
          },
          {
            "name": "4.2 Hydrogen–oxygen fuel cells",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "05 Chemical energetics",
        "open": false,
        "children": [
          {
            "name": "5.1 Exothermic and endothermic reactions",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "06 Chemical reactions",
        "open": false,
        "children": [
          {
            "name": "6.1 Physical and chemical changes",
            "open": false,
            "children": []
          },
          {
            "name": "6.2 Rate of reaction",
            "open": false,
            "children": []
          },
          {
            "name": "6.3 Reversible reactions and equilibrium",
            "open": false,
            "children": []
          },
          {
            "name": "6.4 Redox",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "07 Acids, bases and salts",
        "open": false,
        "children": [
          {
            "name": "7.1 Characteristic properties of acids and bases",
            "open": false,
            "children": []
          },
          {
            "name": "7.2 Oxides",
            "open": false,
            "children": []
          },
          {
            "name": "7.3 Preparation of salts",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "08 The Periodic Table",
        "open": false,
        "children": [
          {
            "name": "8.1 Arrangement of elements",
            "open": false,
            "children": []
          },
          {
            "name": "8.2 Group I",
            "open": false,
            "children": []
          },
          {
            "name": "8.3 Group VII",
            "open": false,
            "children": []
          },
          {
            "name": "8.4 Transition elements",
            "open": false,
            "children": []
          },
          {
            "name": "8.5 Noble gases",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "09 Metals",
        "open": false,
        "children": [
          {
            "name": "9.1 Properties of metals",
            "open": false,
            "children": []
          },
          {
            "name": "9.2 Uses of metals",
            "open": false,
            "children": []
          },
          {
            "name": "9.3 Alloys",
            "open": false,
            "children": []
          },
          {
            "name": "9.4 Reactivity series",
            "open": false,
            "children": []
          },
          {
            "name": "9.5 Corrosion",
            "open": false,
            "children": []
          },
          {
            "name": "9.6 Extraction of metals",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "10 Chemistry of the environment",
        "open": false,
        "children": [
          {
            "name": "10.1 Water",
            "open": false,
            "children": []
          },
          {
            "name": "10.2 Fertilisers",
            "open": false,
            "children": []
          },
          {
            "name": "10.3 Air quality and climate",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "11 Organic chemistry",
        "open": false,
        "children": [
          {
            "name": "11.1 Formulae, functional groups and terminology",
            "open": false,
            "children": []
          },
          {
            "name": "11.2 Naming organic compounds",
            "open": false,
            "children": []
          },
          {
            "name": "11.3 Fuels",
            "open": false,
            "children": []
          },
          {
            "name": "11.4 Alkanes",
            "open": false,
            "children": []
          },
          {
            "name": "11.5 Alkenes",
            "open": false,
            "children": []
          },
          {
            "name": "11.6 Alcohols",
            "open": false,
            "children": []
          },
          {
            "name": "11.7 Carboxylic acids",
            "open": false,
            "children": []
          },
          {
            "name": "11.8 Polymers",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "12 Experimental techniques and chemical analysis",
        "open": false,
        "children": [
          {
            "name": "12.1 Experimental design",
            "open": false,
            "children": []
          },
          {
            "name": "12.2 Acid–base titrations",
            "open": false,
            "children": []
          },
          {
            "name": "12.3 Chromatography",
            "open": false,
            "children": []
          },
          {
            "name": "12.4 Separation and purification",
            "open": false,
            "children": []
          },
          {
            "name": "12.5 Identification of ions and gases",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "13 Practical skills and Alternative to Practical",
        "open": false,
        "children": [
          {
            "name": "13.1 Apparatus and measurement",
            "open": false,
            "children": []
          },
          {
            "name": "13.2 Planning, variables and safety",
            "open": false,
            "children": []
          },
          {
            "name": "13.3 Tables, graphs and calculations",
            "open": false,
            "children": []
          },
          {
            "name": "13.4 Observations, inferences and conclusions",
            "open": false,
            "children": []
          },
          {
            "name": "13.5 Errors, limitations and improvements",
            "open": false,
            "children": []
          },
          {
            "name": "13.6 Qualitative analysis transfer",
            "open": false,
            "children": []
          }
        ]
      }
    ],
    "deckCount": 69
  },
  "Cambridge International AS & A Level Biology 9700": {
    "root": "Cambridge International AS & A Level Biology 9700",
    "open": true,
    "papers": [
      {
        "name": "01 Cell Structure",
        "open": false,
        "children": [
          {
            "name": "01 The Microscope in Cell Studies",
            "open": false,
            "children": []
          },
          {
            "name": "02 Cells as the Basic Units of Living Organisms",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "02 Biological Molecules",
        "open": false,
        "children": [
          {
            "name": "01 Testing for Biological Molecules",
            "open": false,
            "children": []
          },
          {
            "name": "02 Carbohydrates and Lipids",
            "open": false,
            "children": []
          },
          {
            "name": "03 Proteins",
            "open": false,
            "children": []
          },
          {
            "name": "04 Water",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "03 Enzymes",
        "open": false,
        "children": [
          {
            "name": "01 Mode of Action of Enzymes",
            "open": false,
            "children": []
          },
          {
            "name": "02 Factors That Affect Enzyme Action",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "04 Cell Membranes and Transport",
        "open": false,
        "children": [
          {
            "name": "01 Fluid Mosaic Membranes",
            "open": false,
            "children": []
          },
          {
            "name": "02 Movement Into and Out of Cells",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "05 The Mitotic Cell Cycle",
        "open": false,
        "children": [
          {
            "name": "01 Replication and Division of Nuclei and Cells",
            "open": false,
            "children": []
          },
          {
            "name": "02 Chromosome Behaviour in Mitosis",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "06 Nucleic Acids and Protein Synthesis",
        "open": false,
        "children": [
          {
            "name": "01 Structure of Nucleic Acids and Replication of DNA",
            "open": false,
            "children": []
          },
          {
            "name": "02 Protein Synthesis",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "07 Transport in Plants",
        "open": false,
        "children": [
          {
            "name": "01 Structure of Transport Tissues",
            "open": false,
            "children": []
          },
          {
            "name": "02 Transport Mechanisms",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "08 Transport in Mammals",
        "open": false,
        "children": [
          {
            "name": "01 The Circulatory System",
            "open": false,
            "children": []
          },
          {
            "name": "02 Transport of Oxygen and Carbon Dioxide",
            "open": false,
            "children": []
          },
          {
            "name": "03 The Heart",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "09 Gas Exchange",
        "open": false,
        "children": [
          {
            "name": "01 The Gas Exchange System",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "10 Infectious Diseases",
        "open": false,
        "children": [
          {
            "name": "01 Infectious Diseases",
            "open": false,
            "children": []
          },
          {
            "name": "02 Antibiotics",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "11 Immunity",
        "open": false,
        "children": [
          {
            "name": "01 The Immune System",
            "open": false,
            "children": []
          },
          {
            "name": "02 Antibodies and Vaccination",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "12 Energy and Respiration",
        "open": false,
        "children": [
          {
            "name": "01 Energy",
            "open": false,
            "children": []
          },
          {
            "name": "02 Respiration",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "13 Photosynthesis",
        "open": false,
        "children": [
          {
            "name": "01 Photosynthesis as an Energy Transfer Process",
            "open": false,
            "children": []
          },
          {
            "name": "02 Investigation of Limiting Factors",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "14 Homeostasis",
        "open": false,
        "children": [
          {
            "name": "01 Homeostasis in Mammals",
            "open": false,
            "children": []
          },
          {
            "name": "02 Homeostasis in Plants",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "15 Control and Coordination",
        "open": false,
        "children": [
          {
            "name": "01 Control and Coordination in Mammals",
            "open": false,
            "children": []
          },
          {
            "name": "02 Control and Coordination in Plants",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "16 Inheritance",
        "open": false,
        "children": [
          {
            "name": "01 Passage of Information from Parents to Offspring",
            "open": false,
            "children": []
          },
          {
            "name": "02 The Roles of Genes in Determining the Phenotype",
            "open": false,
            "children": []
          },
          {
            "name": "03 Gene Control",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "17 Selection and Evolution",
        "open": false,
        "children": [
          {
            "name": "01 Variation",
            "open": false,
            "children": []
          },
          {
            "name": "02 Natural and Artificial Selection",
            "open": false,
            "children": []
          },
          {
            "name": "03 Evolution",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "18 Classification, Biodiversity and Conservation",
        "open": false,
        "children": [
          {
            "name": "01 Classification",
            "open": false,
            "children": []
          },
          {
            "name": "02 Biodiversity",
            "open": false,
            "children": []
          },
          {
            "name": "03 Conservation",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "19 Genetic Technology",
        "open": false,
        "children": [
          {
            "name": "01 Principles of Genetic Technology",
            "open": false,
            "children": []
          },
          {
            "name": "02 Genetic Technology Applied to Medicine",
            "open": false,
            "children": []
          },
          {
            "name": "03 Genetically Modified Organisms in Agriculture",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "20 Practical Skills",
        "open": false,
        "children": [
          {
            "name": "01 Paper 3 Advanced Practical Skills",
            "open": false,
            "children": []
          },
          {
            "name": "02 Paper 5 Planning, Analysis, Conclusions and Evaluation",
            "open": false,
            "children": []
          }
        ]
      }
    ],
    "deckCount": 67
  },
  "Cambridge International AS & A Level Chemistry 9701": {
    "root": "Cambridge International AS & A Level Chemistry 9701",
    "open": true,
    "papers": [
      {
        "name": "01 AS Physical Chemistry",
        "open": false,
        "children": [
          {
            "name": "01 Atomic Structure",
            "open": false,
            "children": [
              {
                "name": "Electrons, Energy Levels and Atomic Orbitals",
                "open": false,
                "children": []
              },
              {
                "name": "Ionisation Energy",
                "open": false,
                "children": []
              },
              {
                "name": "Particles, Atomic Radius and Isotopes",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "02 Amount of Substance and Stoichiometry",
            "open": false,
            "children": [
              {
                "name": "Formulae and Equations",
                "open": false,
                "children": []
              },
              {
                "name": "Reacting Masses and Gas or Solution Volumes",
                "open": false,
                "children": []
              },
              {
                "name": "Relative Masses and the Mole",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "03 Chemical Bonding",
            "open": false,
            "children": [
              {
                "name": "Covalent and Coordinate Bonding",
                "open": false,
                "children": []
              },
              {
                "name": "Dot-and-Cross Diagrams",
                "open": false,
                "children": []
              },
              {
                "name": "Electronegativity, Ionic and Metallic Bonding",
                "open": false,
                "children": []
              },
              {
                "name": "Shapes and Intermolecular Forces",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "04 States of Matter",
            "open": false,
            "children": [
              {
                "name": "Ideal and Real Gases",
                "open": false,
                "children": []
              },
              {
                "name": "Structure, Bonding and Properties",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "05 Chemical Energetics",
            "open": false,
            "children": [
              {
                "name": "Enthalpy Changes and Calorimetry",
                "open": false,
                "children": []
              },
              {
                "name": "Hess Cycles and Bond Energies",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "06 Redox and Electrochemistry",
            "open": false,
            "children": []
          },
          {
            "name": "07 Equilibria and Acids-Bases",
            "open": false,
            "children": [
              {
                "name": "Bronsted-Lowry Acids, Bases and pH",
                "open": false,
                "children": []
              },
              {
                "name": "Dynamic Equilibrium and Kc",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "08 Reaction Kinetics and Catalysis",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "02 AS Inorganic Chemistry",
        "open": false,
        "children": [
          {
            "name": "01 Period 3 Periodicity",
            "open": false,
            "children": []
          },
          {
            "name": "02 Group 2",
            "open": false,
            "children": []
          },
          {
            "name": "03 Group 17",
            "open": false,
            "children": []
          },
          {
            "name": "04 Nitrogen and Sulfur",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "03 AS Organic Chemistry and Analysis",
        "open": false,
        "children": [
          {
            "name": "01 Organic Foundations and Isomerism",
            "open": false,
            "children": []
          },
          {
            "name": "02 Alkanes",
            "open": false,
            "children": []
          },
          {
            "name": "03 Alkenes",
            "open": false,
            "children": []
          },
          {
            "name": "04 Halogenoalkanes",
            "open": false,
            "children": []
          },
          {
            "name": "05 Alcohols",
            "open": false,
            "children": []
          },
          {
            "name": "06 Aldehydes and Ketones",
            "open": false,
            "children": []
          },
          {
            "name": "07 Carboxylic Acids and Esters",
            "open": false,
            "children": []
          },
          {
            "name": "08 Amines, Nitriles and Hydroxynitriles",
            "open": false,
            "children": []
          },
          {
            "name": "09 Addition Polymerisation",
            "open": false,
            "children": []
          },
          {
            "name": "10 Organic Synthesis",
            "open": false,
            "children": []
          },
          {
            "name": "11 Infrared and Mass Spectrometry",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "04 A Level Physical Chemistry",
        "open": false,
        "children": [
          {
            "name": "01 Lattice Energy and Born-Haber Cycles",
            "open": false,
            "children": []
          },
          {
            "name": "02 Solution and Hydration Enthalpy",
            "open": false,
            "children": []
          },
          {
            "name": "03 Entropy and Gibbs Free Energy",
            "open": false,
            "children": []
          },
          {
            "name": "04 Electrolysis",
            "open": false,
            "children": []
          },
          {
            "name": "05 Electrode Potentials, Cells and Nernst Equation",
            "open": false,
            "children": []
          },
          {
            "name": "06 Acids, Bases, Buffers and Titration Curves",
            "open": false,
            "children": []
          },
          {
            "name": "07 Partition Coefficients",
            "open": false,
            "children": []
          },
          {
            "name": "08 Rate Equations and Mechanistic Evidence",
            "open": false,
            "children": []
          },
          {
            "name": "09 Homogeneous and Heterogeneous Catalysis",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "05 A Level Inorganic Chemistry",
        "open": false,
        "children": [
          {
            "name": "01 Advanced Group 2",
            "open": false,
            "children": []
          },
          {
            "name": "02 Transition Elements",
            "open": false,
            "children": [
              {
                "name": "Colours and Qualitative Reactions",
                "open": false,
                "children": []
              },
              {
                "name": "Complex Stereoisomerism",
                "open": false,
                "children": []
              },
              {
                "name": "General Properties and Complex Formation",
                "open": false,
                "children": []
              },
              {
                "name": "Ligand Exchange, Redox and Catalysis",
                "open": false,
                "children": []
              },
              {
                "name": "Stability Constants",
                "open": false,
                "children": []
              }
            ]
          }
        ]
      },
      {
        "name": "06 A Level Organic Chemistry and Analysis",
        "open": false,
        "children": [
          {
            "name": "01 Aromatic Foundations and Optical Isomerism",
            "open": false,
            "children": []
          },
          {
            "name": "02 Arenes",
            "open": false,
            "children": []
          },
          {
            "name": "03 Halogen Compounds",
            "open": false,
            "children": []
          },
          {
            "name": "04 Alcohols and Phenol",
            "open": false,
            "children": []
          },
          {
            "name": "05 Carboxylic Acids, Esters and Acyl Chlorides",
            "open": false,
            "children": []
          },
          {
            "name": "06 Amines, Phenylamine and Azo Compounds",
            "open": false,
            "children": []
          },
          {
            "name": "07 Amides and Amino Acids",
            "open": false,
            "children": []
          },
          {
            "name": "08 Condensation and Degradable Polymers",
            "open": false,
            "children": []
          },
          {
            "name": "09 Multi-Step Organic Synthesis",
            "open": false,
            "children": []
          },
          {
            "name": "10 Chromatography and NMR Spectroscopy",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "07 Practical Skills - Paper 3",
        "open": false,
        "children": [
          {
            "name": "01 Titration and Volumetric Analysis",
            "open": false,
            "children": []
          },
          {
            "name": "02 Gravimetric and Thermal Analysis",
            "open": false,
            "children": []
          },
          {
            "name": "03 Rates, Energetics and Gas Measurements",
            "open": false,
            "children": []
          },
          {
            "name": "04 Qualitative Analysis and Deduction",
            "open": false,
            "children": []
          },
          {
            "name": "05 Recording, Precision and Significant Figures",
            "open": false,
            "children": []
          },
          {
            "name": "06 Graphs, Calculations and Conclusions",
            "open": false,
            "children": []
          },
          {
            "name": "07 Errors, Limitations and Improvements",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "08 Planning, Analysis and Evaluation - Paper 5",
        "open": false,
        "children": [
          {
            "name": "01 Defining the Problem and Variables",
            "open": false,
            "children": []
          },
          {
            "name": "02 Designing a Safe and Effective Method",
            "open": false,
            "children": []
          },
          {
            "name": "03 Apparatus, Precision and Control Experiments",
            "open": false,
            "children": []
          },
          {
            "name": "04 Tables, Predictions and Graph Planning",
            "open": false,
            "children": []
          },
          {
            "name": "05 Processing and Transforming Data",
            "open": false,
            "children": []
          },
          {
            "name": "06 Conclusions and Scientific Explanations",
            "open": false,
            "children": []
          },
          {
            "name": "07 Reliability, Validity and Evaluation",
            "open": false,
            "children": []
          }
        ]
      }
    ],
    "deckCount": 88
  },
  "OCR A A-Level Biology H420": {
    "root": "OCR A A-Level Biology H420",
    "open": true,
    "papers": [
      {
        "name": "01 Development of Practical Skills",
        "open": false,
        "children": [
          {
            "name": "01 Planning Investigations",
            "open": false,
            "children": []
          },
          {
            "name": "02 Implementing Investigations",
            "open": false,
            "children": []
          },
          {
            "name": "03 Analysis of Results",
            "open": false,
            "children": []
          },
          {
            "name": "04 Evaluation of Procedures and Data",
            "open": false,
            "children": []
          },
          {
            "name": "05 Practical Activity Groups",
            "open": false,
            "children": [
              {
                "name": "01 Microscopy",
                "open": false,
                "children": []
              },
              {
                "name": "02 Dissection",
                "open": false,
                "children": []
              },
              {
                "name": "03 Sampling Techniques",
                "open": false,
                "children": []
              },
              {
                "name": "04 Enzyme-Controlled Reaction Rates",
                "open": false,
                "children": []
              },
              {
                "name": "05 Colorimetry or Potometry",
                "open": false,
                "children": []
              },
              {
                "name": "06 Chromatography or Electrophoresis",
                "open": false,
                "children": []
              },
              {
                "name": "07 Microbiological Techniques",
                "open": false,
                "children": []
              },
              {
                "name": "08 Transport In and Out of Cells",
                "open": false,
                "children": []
              },
              {
                "name": "09 Qualitative Testing",
                "open": false,
                "children": []
              },
              {
                "name": "10 Data Logging or Computer Modelling",
                "open": false,
                "children": []
              },
              {
                "name": "11 Plant or Animal Responses",
                "open": false,
                "children": []
              },
              {
                "name": "12 Research Skills",
                "open": false,
                "children": []
              }
            ]
          }
        ]
      },
      {
        "name": "02 Foundations in Biology",
        "open": false,
        "children": [
          {
            "name": "01 Cell Structure",
            "open": false,
            "children": []
          },
          {
            "name": "02 Biological Molecules",
            "open": false,
            "children": []
          },
          {
            "name": "03 Nucleotides and Nucleic Acids",
            "open": false,
            "children": []
          },
          {
            "name": "04 Enzymes",
            "open": false,
            "children": []
          },
          {
            "name": "05 Biological Membranes",
            "open": false,
            "children": []
          },
          {
            "name": "06 Cell Division, Diversity and Organisation",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "03 Exchange and Transport",
        "open": false,
        "children": [
          {
            "name": "01 Exchange Surfaces",
            "open": false,
            "children": []
          },
          {
            "name": "02 Transport in Animals",
            "open": false,
            "children": []
          },
          {
            "name": "03 Transport in Plants",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "04 Biodiversity, Evolution and Disease",
        "open": false,
        "children": [
          {
            "name": "01 Communicable Diseases and Immunity",
            "open": false,
            "children": []
          },
          {
            "name": "02 Biodiversity",
            "open": false,
            "children": []
          },
          {
            "name": "03 Classification and Evolution",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "05 Communication, Homeostasis and Energy",
        "open": false,
        "children": [
          {
            "name": "01 Communication and Homeostasis",
            "open": false,
            "children": []
          },
          {
            "name": "02 Excretion and Homeostatic Control",
            "open": false,
            "children": []
          },
          {
            "name": "03 Neuronal Communication",
            "open": false,
            "children": []
          },
          {
            "name": "04 Hormonal Communication",
            "open": false,
            "children": []
          },
          {
            "name": "05 Plant and Animal Responses",
            "open": false,
            "children": []
          },
          {
            "name": "06 Photosynthesis",
            "open": false,
            "children": []
          },
          {
            "name": "07 Respiration",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "06 Genetics, Evolution and Ecosystems",
        "open": false,
        "children": [
          {
            "name": "01 Cellular Control",
            "open": false,
            "children": []
          },
          {
            "name": "02 Patterns of Inheritance",
            "open": false,
            "children": []
          },
          {
            "name": "03 Manipulating Genomes",
            "open": false,
            "children": []
          },
          {
            "name": "04 Cloning and Biotechnology",
            "open": false,
            "children": []
          },
          {
            "name": "05 Ecosystems",
            "open": false,
            "children": []
          },
          {
            "name": "06 Populations and Sustainability",
            "open": false,
            "children": []
          }
        ]
      }
    ],
    "deckCount": 49
  },
  "OCR A GCSE Biology A J247": {
    "root": "OCR A GCSE Biology A J247",
    "open": true,
    "papers": [
      {
        "name": "B1 Cell level systems",
        "open": false,
        "children": [
          {
            "name": "B1.1 Cell structures",
            "open": false,
            "children": []
          },
          {
            "name": "B1.2 What happens in cells (and what do cells need)?",
            "open": false,
            "children": []
          },
          {
            "name": "B1.3 Respiration",
            "open": false,
            "children": []
          },
          {
            "name": "B1.4 Photosynthesis",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "B2 Scaling up",
        "open": false,
        "children": [
          {
            "name": "B2.1 Supplying the cell",
            "open": false,
            "children": []
          },
          {
            "name": "B2.2 The challenges of size",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "B3 Organism level systems",
        "open": false,
        "children": [
          {
            "name": "B3.1 Coordination and control: the nervous system",
            "open": false,
            "children": []
          },
          {
            "name": "B3.2 Coordination and control: the endocrine system",
            "open": false,
            "children": []
          },
          {
            "name": "B3.3 Maintaining internal environments",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "B4 Community level systems",
        "open": false,
        "children": [
          {
            "name": "B4.1 Ecosystems",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "B5 Genes, inheritance and selection",
        "open": false,
        "children": [
          {
            "name": "B5.1 Inheritance",
            "open": false,
            "children": []
          },
          {
            "name": "B5.2 Natural selection and evolution",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "B6 Global challenges",
        "open": false,
        "children": [
          {
            "name": "B6.1 Monitoring and maintaining the environment",
            "open": false,
            "children": []
          },
          {
            "name": "B6.2 Feeding the human race",
            "open": false,
            "children": []
          },
          {
            "name": "B6.3 Monitoring and maintaining health",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "B7 Practical skills",
        "open": false,
        "children": [
          {
            "name": "PAG B1 Microscopy",
            "open": false,
            "children": []
          },
          {
            "name": "PAG B2 Testing biological molecules",
            "open": false,
            "children": []
          },
          {
            "name": "PAG B3 Sampling techniques",
            "open": false,
            "children": []
          },
          {
            "name": "PAG B4 Rates of enzyme-controlled reactions",
            "open": false,
            "children": []
          },
          {
            "name": "PAG B5 Photosynthesis",
            "open": false,
            "children": []
          },
          {
            "name": "PAG B6 Physiology, responses and respiration",
            "open": false,
            "children": []
          },
          {
            "name": "PAG B7 Microbiological techniques",
            "open": false,
            "children": []
          },
          {
            "name": "PAG B8 Transport in and out of cells",
            "open": false,
            "children": []
          }
        ]
      }
    ],
    "deckCount": 31
  },
  "OCR A GCSE Physics (Gateway A)": {
    "root": "OCR A GCSE Physics (Gateway A)",
    "open": true,
    "papers": [
      {
        "name": "1. Matter",
        "open": false,
        "children": [
          {
            "name": "P1.1 The particle model",
            "open": false,
            "children": []
          },
          {
            "name": "P1.2 Changes of state",
            "open": false,
            "children": []
          },
          {
            "name": "P1.3 Pressure",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "2. Forces",
        "open": false,
        "children": [
          {
            "name": "P2.1 Motion",
            "open": false,
            "children": []
          },
          {
            "name": "P2.2 Newton's laws",
            "open": false,
            "children": []
          },
          {
            "name": "P2.3 Forces in action",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "3. Electricity",
        "open": false,
        "children": [
          {
            "name": "P3.1 Static and charge",
            "open": false,
            "children": []
          },
          {
            "name": "P3.2 Simple circuits",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "4. Magnetism",
        "open": false,
        "children": [
          {
            "name": "P4.1 Magnets and magnetic fields",
            "open": false,
            "children": []
          },
          {
            "name": "P4.2 Uses of magnetism",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "5. Waves in Matter",
        "open": false,
        "children": [
          {
            "name": "P5.1 Wave behaviour",
            "open": false,
            "children": []
          },
          {
            "name": "P5.2 The electromagnetic spectrum",
            "open": false,
            "children": []
          },
          {
            "name": "P5.3 Wave interaction",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "6. Radioactivity",
        "open": false,
        "children": [
          {
            "name": "P6.1 Radioactive emissions",
            "open": false,
            "children": []
          },
          {
            "name": "P6.2 Uses and hazards",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "7. Energy",
        "open": false,
        "children": [
          {
            "name": "P7.1 Work done",
            "open": false,
            "children": []
          },
          {
            "name": "P7.2 Power and efficiency",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "8. Global Challenges",
        "open": false,
        "children": [
          {
            "name": "P8.1 Physics on the move",
            "open": false,
            "children": []
          },
          {
            "name": "P8.2 Powering Earth",
            "open": false,
            "children": []
          },
          {
            "name": "P8.3 Beyond Earth",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "9. Practical Skills",
        "open": false,
        "children": [
          {
            "name": "P1 Materials",
            "open": false,
            "children": []
          },
          {
            "name": "P2 Forces",
            "open": false,
            "children": []
          },
          {
            "name": "P3 Motion",
            "open": false,
            "children": []
          },
          {
            "name": "P4 Measuring waves",
            "open": false,
            "children": []
          },
          {
            "name": "P5 Energy",
            "open": false,
            "children": []
          },
          {
            "name": "P6 Circuit components",
            "open": false,
            "children": []
          },
          {
            "name": "P7 Series and parallel circuits",
            "open": false,
            "children": []
          },
          {
            "name": "P8 Interactions of waves",
            "open": false,
            "children": []
          }
        ]
      }
    ],
    "deckCount": 38
  },
  "OCR A-Level Physics": {
    "root": "OCR A-Level Physics",
    "open": true,
    "papers": [
      {
        "name": "00 Foundations of Physics",
        "open": false,
        "children": []
      },
      {
        "name": "01 Paper 1 - Modelling Physics",
        "open": false,
        "children": [
          {
            "name": "01 Forces and Motion",
            "open": false,
            "children": [
              {
                "name": "01 Motion",
                "open": false,
                "children": []
              },
              {
                "name": "02 Forces in action",
                "open": false,
                "children": []
              },
              {
                "name": "03 Work Energy and Power",
                "open": false,
                "children": []
              },
              {
                "name": "04 Materials",
                "open": false,
                "children": []
              },
              {
                "name": "05 Newtons Laws and Momentum",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "02 Newtonian World and Astrophysics",
            "open": false,
            "children": [
              {
                "name": "01 Thermal Physics",
                "open": false,
                "children": []
              },
              {
                "name": "02 Circular Motion",
                "open": false,
                "children": []
              },
              {
                "name": "03 Oscillations",
                "open": false,
                "children": []
              },
              {
                "name": "04 Gravitational Fields",
                "open": false,
                "children": []
              },
              {
                "name": "05 Astrophysics and Cosmology",
                "open": false,
                "children": [
                  {
                    "name": "5.1 Stars",
                    "open": false,
                    "children": []
                  },
                  {
                    "name": "5.2 Electromagnetic radiation from stars",
                    "open": false,
                    "children": []
                  },
                  {
                    "name": "5.3 Cosmology",
                    "open": false,
                    "children": []
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "name": "02 Paper 2 - Exploring Physics",
        "open": false,
        "children": [
          {
            "name": "01 Electrons Waves and Photons",
            "open": false,
            "children": [
              {
                "name": "01 Electricity",
                "open": false,
                "children": [
                  {
                    "name": "1.1 Charge and Current",
                    "open": false,
                    "children": []
                  },
                  {
                    "name": "1.2 Energy, Power and Resistance",
                    "open": false,
                    "children": []
                  },
                  {
                    "name": "1.3 Electrical Circuits",
                    "open": false,
                    "children": []
                  }
                ]
              },
              {
                "name": "02 Waves",
                "open": false,
                "children": []
              },
              {
                "name": "03 Quantum Physics",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "02 Particles and Medical Physics",
            "open": false,
            "children": [
              {
                "name": "01 Capacitors",
                "open": false,
                "children": []
              },
              {
                "name": "02 Electric Fields",
                "open": false,
                "children": []
              },
              {
                "name": "03 Magnetic Fields",
                "open": false,
                "children": []
              },
              {
                "name": "04 Nuclear and Particle Physics",
                "open": false,
                "children": []
              },
              {
                "name": "05 Medical Imaging",
                "open": false,
                "children": []
              }
            ]
          }
        ]
      },
      {
        "name": "03 PAGs and Practical Skills",
        "open": false,
        "children": [
          {
            "name": "01 Practical Skills",
            "open": false,
            "children": []
          },
          {
            "name": "05 All PAGs",
            "open": false,
            "children": [
              {
                "name": "01 PAG 01 - Mechanics",
                "open": false,
                "children": []
              },
              {
                "name": "02 PAG 02 - Materials",
                "open": false,
                "children": []
              },
              {
                "name": "03 PAG 03 - Resistivity and Cells",
                "open": false,
                "children": []
              },
              {
                "name": "04 PAG 04 - Circuits and Sensors",
                "open": false,
                "children": []
              },
              {
                "name": "05 PAG 05 - Waves",
                "open": false,
                "children": []
              },
              {
                "name": "06 PAG 06 - Quantum and EM Waves",
                "open": false,
                "children": []
              },
              {
                "name": "07 PAG 07 - Nuclear Physics",
                "open": false,
                "children": []
              },
              {
                "name": "08 PAG 08 - Thermal Physics",
                "open": false,
                "children": []
              },
              {
                "name": "09 PAG 09 - Capacitors",
                "open": false,
                "children": []
              },
              {
                "name": "10 PAG 10 - Oscillations",
                "open": false,
                "children": []
              },
              {
                "name": "11 PAG 11 - Fields and Energy Transfer",
                "open": false,
                "children": []
              },
              {
                "name": "12 PAG 12 - Research Skills",
                "open": false,
                "children": []
              }
            ]
          }
        ]
      }
    ],
    "deckCount": 47
  },
  "OCR GCSE Biology B J257": {
    "root": "OCR GCSE Biology B J257",
    "open": true,
    "papers": [
      {
        "name": "B1 You and your genes",
        "open": false,
        "children": [
          {
            "name": "B1.1 What is the genome and what does it do?",
            "open": false,
            "children": []
          },
          {
            "name": "B1.2 How is genetic information inherited?",
            "open": false,
            "children": []
          },
          {
            "name": "B1.3 How can and should gene technology be used?",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "B2 Keeping healthy",
        "open": false,
        "children": [
          {
            "name": "B2.1 What are the causes of disease?",
            "open": false,
            "children": []
          },
          {
            "name": "B2.2 How do organisms protect themselves against pathogens?",
            "open": false,
            "children": []
          },
          {
            "name": "B2.3 How can we prevent the spread of infections?",
            "open": false,
            "children": []
          },
          {
            "name": "B2.4 How can we identify the cause of an infection?",
            "open": false,
            "children": []
          },
          {
            "name": "B2.5 How can lifestyle, genes and the environment affect health?",
            "open": false,
            "children": []
          },
          {
            "name": "B2.6 How can we treat disease?",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "B3 Living together - food and ecosystems",
        "open": false,
        "children": [
          {
            "name": "B3.1 What happens during photosynthesis?",
            "open": false,
            "children": []
          },
          {
            "name": "B3.2 How do producers get the substances they need?",
            "open": false,
            "children": []
          },
          {
            "name": "B3.3 How are organisms in an ecosystem interdependent?",
            "open": false,
            "children": []
          },
          {
            "name": "B3.4 How are populations affected by conditions in an ecosystem?",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "B4 Using food and controlling growth",
        "open": false,
        "children": [
          {
            "name": "B4.1 What happens during cellular respiration?",
            "open": false,
            "children": []
          },
          {
            "name": "B4.2 How do we know about mitochondria and other cell structures?",
            "open": false,
            "children": []
          },
          {
            "name": "B4.3 How do organisms grow and develop?",
            "open": false,
            "children": []
          },
          {
            "name": "B4.4 How is plant growth controlled?",
            "open": false,
            "children": []
          },
          {
            "name": "B4.5 Should we use stem cells to treat damage and disease?",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "B5 The human body - staying alive",
        "open": false,
        "children": [
          {
            "name": "B5.1 How do substances get into, out of and around our bodies?",
            "open": false,
            "children": []
          },
          {
            "name": "B5.2 How does the nervous system help us respond to changes?",
            "open": false,
            "children": []
          },
          {
            "name": "B5.3 How do hormones control responses in the human body?",
            "open": false,
            "children": []
          },
          {
            "name": "B5.4 Why do we need to maintain a constant internal environment?",
            "open": false,
            "children": []
          },
          {
            "name": "B5.5 What role do hormones play in human reproduction?",
            "open": false,
            "children": []
          },
          {
            "name": "B5.6 What can happen when organs and control systems stop working?",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "B6 Life on Earth - past, present and future",
        "open": false,
        "children": [
          {
            "name": "B6.1 How was the theory of evolution developed?",
            "open": false,
            "children": []
          },
          {
            "name": "B6.2 How do sexual and asexual reproduction affect evolution?",
            "open": false,
            "children": []
          },
          {
            "name": "B6.3 How does our understanding of biology help us classify the diversity of organisms on Earth?",
            "open": false,
            "children": []
          },
          {
            "name": "B6.4 How is biodiversity threatened and how can we protect it?",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "B7 Ideas about Science",
        "open": false,
        "children": [
          {
            "name": "IaS1 What needs to be considered when investigating a phenomenon scientifically?",
            "open": false,
            "children": []
          },
          {
            "name": "IaS2 What conclusions can we make from data?",
            "open": false,
            "children": []
          },
          {
            "name": "IaS3 How are scientific explanations developed?",
            "open": false,
            "children": []
          },
          {
            "name": "IaS4 How do science and technology impact society?",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "B8 Practical skills",
        "open": false,
        "children": [
          {
            "name": "PAG1 Microscopy",
            "open": false,
            "children": []
          },
          {
            "name": "PAG2 Testing for biological molecules",
            "open": false,
            "children": []
          },
          {
            "name": "PAG3 Sampling techniques",
            "open": false,
            "children": []
          },
          {
            "name": "PAG4 Rates of enzyme-controlled reactions",
            "open": false,
            "children": []
          },
          {
            "name": "PAG5 Photosynthesis",
            "open": false,
            "children": []
          },
          {
            "name": "PAG6 Physiology, responses and respiration",
            "open": false,
            "children": []
          },
          {
            "name": "PAG7 Microbiological techniques",
            "open": false,
            "children": []
          },
          {
            "name": "PAG8 Transport in and out of cells",
            "open": false,
            "children": []
          }
        ]
      }
    ],
    "deckCount": 49
  },
  "OCR Gateway GCSE Chemistry A (J248)": {
    "root": "OCR Gateway GCSE Chemistry A (J248)",
    "open": true,
    "papers": [
      {
        "name": "01 Particles",
        "open": false,
        "children": [
          {
            "name": "C1.1 The particle model",
            "open": false,
            "children": []
          },
          {
            "name": "C1.2 Atomic structure",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "02 Elements, compounds and mixtures",
        "open": false,
        "children": [
          {
            "name": "C2.1 Purity and separating mixtures",
            "open": false,
            "children": []
          },
          {
            "name": "C2.2 Bonding",
            "open": false,
            "children": []
          },
          {
            "name": "C2.3 Properties of materials",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "03 Chemical reactions",
        "open": false,
        "children": [
          {
            "name": "C3.1 Introducing chemical reactions",
            "open": false,
            "children": []
          },
          {
            "name": "C3.2 Energetics",
            "open": false,
            "children": []
          },
          {
            "name": "C3.3 Types of chemical reactions",
            "open": false,
            "children": []
          },
          {
            "name": "C3.4 Electrolysis",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "04 Predicting and identifying reactions and products",
        "open": false,
        "children": [
          {
            "name": "C4.1 Predicting chemical reactions",
            "open": false,
            "children": []
          },
          {
            "name": "C4.2 Identifying products",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "05 Monitoring and controlling chemical reactions",
        "open": false,
        "children": [
          {
            "name": "C5.1 Monitoring chemical reactions",
            "open": false,
            "children": []
          },
          {
            "name": "C5.2 Controlling reactions",
            "open": false,
            "children": []
          },
          {
            "name": "C5.3 Equilibria",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "06 Global challenges",
        "open": false,
        "children": [
          {
            "name": "C6.1 Improving processes and products",
            "open": false,
            "children": []
          },
          {
            "name": "C6.2 Organic chemistry",
            "open": false,
            "children": []
          },
          {
            "name": "C6.3 Interpreting and interacting with Earth systems",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "07 Practical skills",
        "open": false,
        "children": [
          {
            "name": "PAG1 Reactivity trends",
            "open": false,
            "children": []
          },
          {
            "name": "PAG2 Electrolysis",
            "open": false,
            "children": []
          },
          {
            "name": "PAG3 Separation techniques",
            "open": false,
            "children": []
          },
          {
            "name": "PAG4 Distillation",
            "open": false,
            "children": []
          },
          {
            "name": "PAG5 Identification of species",
            "open": false,
            "children": []
          },
          {
            "name": "PAG6 Titration",
            "open": false,
            "children": []
          },
          {
            "name": "PAG7 Production of salts",
            "open": false,
            "children": []
          },
          {
            "name": "PAG8 Measuring rates of reaction",
            "open": false,
            "children": []
          }
        ]
      }
    ],
    "deckCount": 33
  },
  "Pearson Edexcel A Level Chemistry (9CH0)": {
    "root": "Pearson Edexcel A Level Chemistry (9CH0)",
    "open": true,
    "papers": [
      {
        "name": "01 Atomic Structure and the Periodic Table",
        "open": false,
        "children": [
          {
            "name": "01 Atomic Structure, Isotopes and Mass Spectrometry",
            "open": false,
            "children": []
          },
          {
            "name": "02 Ionisation Energies and Atomic Models",
            "open": false,
            "children": []
          },
          {
            "name": "03 Orbitals and Electronic Configuration",
            "open": false,
            "children": []
          },
          {
            "name": "04 Periodicity in Periods 2 and 3",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "02 Bonding and Structure",
        "open": false,
        "children": [
          {
            "name": "01 Ionic, Covalent and Dative Bonding",
            "open": false,
            "children": []
          },
          {
            "name": "02 Shapes, Bond Angles and Polarity",
            "open": false,
            "children": []
          },
          {
            "name": "03 Intermolecular Forces and Solubility",
            "open": false,
            "children": []
          },
          {
            "name": "04 Giant and Simple Structures",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "03 Redox I",
        "open": false,
        "children": [
          {
            "name": "01 Oxidation Numbers and Redox Classification",
            "open": false,
            "children": []
          },
          {
            "name": "02 Half-equations and Ionic Equations",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "04 Inorganic Chemistry and the Periodic Table",
        "open": false,
        "children": [
          {
            "name": "01 Groups 1 and 2",
            "open": false,
            "children": []
          },
          {
            "name": "02 Group 7",
            "open": false,
            "children": []
          },
          {
            "name": "03 Inorganic Tests and Ionic Equations",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "05 Formulae, Equations and Amounts of Substance",
        "open": false,
        "children": [
          {
            "name": "01 Moles, Formulae and Equations",
            "open": false,
            "children": []
          },
          {
            "name": "02 Gases and Solutions",
            "open": false,
            "children": []
          },
          {
            "name": "03 Titrations, Yield and Atom Economy",
            "open": false,
            "children": []
          },
          {
            "name": "04 Uncertainty, Error, Risk and Observations",
            "open": false,
            "children": []
          },
          {
            "name": "05 Core Practical 1 — Molar Volume of a Gas",
            "open": false,
            "children": []
          },
          {
            "name": "06 Core Practical 2 — Standard Solution and Sodium Hydroxide",
            "open": false,
            "children": []
          },
          {
            "name": "07 Core Practical 3 — Hydrochloric Acid Concentration",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "06 Organic Chemistry I",
        "open": false,
        "children": [
          {
            "name": "01 Formulae, Nomenclature and Isomerism",
            "open": false,
            "children": []
          },
          {
            "name": "02 Alkanes, Fuels and Radical Substitution",
            "open": false,
            "children": []
          },
          {
            "name": "03 Alkenes and Electrophilic Addition",
            "open": false,
            "children": []
          },
          {
            "name": "04 Halogenoalkanes and Nucleophilic Substitution",
            "open": false,
            "children": []
          },
          {
            "name": "05 Alcohols and Organic Techniques",
            "open": false,
            "children": []
          },
          {
            "name": "06 Core Practical 4 — Halogenoalkane Hydrolysis",
            "open": false,
            "children": []
          },
          {
            "name": "07 Core Practical 5 — Oxidation of Ethanol",
            "open": false,
            "children": []
          },
          {
            "name": "08 Core Practical 6 — Chlorination of 2-methylpropan-2-ol",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "07 Modern Analytical Techniques I",
        "open": false,
        "children": [
          {
            "name": "01 Organic Mass Spectrometry",
            "open": false,
            "children": []
          },
          {
            "name": "02 Infrared Spectroscopy",
            "open": false,
            "children": []
          },
          {
            "name": "03 Core Practical 7 — Analysis of Unknowns",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "08 Energetics I",
        "open": false,
        "children": [
          {
            "name": "01 Enthalpy Changes and Calorimetry",
            "open": false,
            "children": []
          },
          {
            "name": "02 Hess Cycles and Bond Enthalpies",
            "open": false,
            "children": []
          },
          {
            "name": "03 Core Practical 8 — Hess's Law",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "09 Kinetics I",
        "open": false,
        "children": [
          {
            "name": "01 Collision Theory and Maxwell–Boltzmann Distributions",
            "open": false,
            "children": []
          },
          {
            "name": "02 Rate Graphs and Catalysts",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "10 Equilibrium I",
        "open": false,
        "children": [
          {
            "name": "01 Dynamic Equilibrium and Le Chatelier's Principle",
            "open": false,
            "children": []
          },
          {
            "name": "02 Equilibrium Constants Kc",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "11 Equilibrium II",
        "open": false,
        "children": [
          {
            "name": "01 Partial Pressure and Kp",
            "open": false,
            "children": []
          },
          {
            "name": "02 Industrial Equilibria and Data Interpretation",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "12 Acid-base Equilibria",
        "open": false,
        "children": [
          {
            "name": "01 Acids, Bases, pH and Kw",
            "open": false,
            "children": []
          },
          {
            "name": "02 Ka, Weak Acids and Buffers",
            "open": false,
            "children": []
          },
          {
            "name": "03 Titration Curves and Indicators",
            "open": false,
            "children": []
          },
          {
            "name": "04 Core Practical 9 — Ka of a Weak Acid",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "13 Energetics II",
        "open": false,
        "children": [
          {
            "name": "01 Lattice Enthalpy, Hydration and Solution",
            "open": false,
            "children": []
          },
          {
            "name": "02 Entropy, Feasibility and Temperature",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "14 Redox II",
        "open": false,
        "children": [
          {
            "name": "01 Electrode Potentials and Electrochemical Cells",
            "open": false,
            "children": []
          },
          {
            "name": "02 Storage Cells and Fuel Cells",
            "open": false,
            "children": []
          },
          {
            "name": "03 Redox Titrations",
            "open": false,
            "children": []
          },
          {
            "name": "04 Core Practical 10 — Electrochemical Cells",
            "open": false,
            "children": []
          },
          {
            "name": "05 Core Practical 11 — Redox Titration",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "15 Transition Metals",
        "open": false,
        "children": [
          {
            "name": "01 Electronic Structure, Ligands and Complexes",
            "open": false,
            "children": []
          },
          {
            "name": "02 Shapes, Isomerism and Colour",
            "open": false,
            "children": []
          },
          {
            "name": "03 Vanadium and Chromium Redox Chemistry",
            "open": false,
            "children": []
          },
          {
            "name": "04 Hydroxide, Ammonia and Ligand-exchange Reactions",
            "open": false,
            "children": []
          },
          {
            "name": "05 Transition-metal Catalysis",
            "open": false,
            "children": []
          },
          {
            "name": "06 Core Practical 12 — Preparation of a Transition-metal Complex",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "16 Kinetics II",
        "open": false,
        "children": [
          {
            "name": "01 Rate Equations, Orders and Rate Constants",
            "open": false,
            "children": []
          },
          {
            "name": "02 Mechanisms and Rate-determining Steps",
            "open": false,
            "children": []
          },
          {
            "name": "03 Arrhenius Equation and Activation Energy",
            "open": false,
            "children": []
          },
          {
            "name": "04 Core Practical 13a — Iodine–Propanone Titrimetric Rate",
            "open": false,
            "children": []
          },
          {
            "name": "05 Core Practical 13b — Iodine Clock",
            "open": false,
            "children": []
          },
          {
            "name": "06 Core Practical 14 — Activation Energy",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "17 Organic Chemistry II",
        "open": false,
        "children": [
          {
            "name": "01 Chirality and Optical Evidence for SN1/SN2",
            "open": false,
            "children": []
          },
          {
            "name": "02 Carbonyl Compounds",
            "open": false,
            "children": []
          },
          {
            "name": "03 Carboxylic Acids, Acyl Chlorides, Esters and Polyesters",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "18 Organic Chemistry III",
        "open": false,
        "children": [
          {
            "name": "01 Benzene and Electrophilic Substitution",
            "open": false,
            "children": []
          },
          {
            "name": "02 Phenol",
            "open": false,
            "children": []
          },
          {
            "name": "03 Amines, Amides, Amino Acids and Proteins",
            "open": false,
            "children": []
          },
          {
            "name": "04 Functional-group Analysis and Core Practical 15",
            "open": false,
            "children": []
          },
          {
            "name": "05 Multi-step Organic Synthesis and Grignard Reagents",
            "open": false,
            "children": []
          },
          {
            "name": "06 Core Practical 16 — Preparation of Aspirin",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "19 Modern Analytical Techniques II",
        "open": false,
        "children": [
          {
            "name": "01 Accurate-mass Spectrometry",
            "open": false,
            "children": []
          },
          {
            "name": "02 Carbon-13 NMR",
            "open": false,
            "children": []
          },
          {
            "name": "03 High-resolution Proton NMR",
            "open": false,
            "children": []
          },
          {
            "name": "04 Chromatography, HPLC, GC and Coupled MS",
            "open": false,
            "children": []
          }
        ]
      }
    ],
    "deckCount": 96
  },
  "Pearson Edexcel A Level Physics 9PH0": {
    "root": "Pearson Edexcel A Level Physics 9PH0",
    "open": true,
    "papers": [
      {
        "name": "0.0 Shared Skills",
        "open": false,
        "children": [
          {
            "name": "0.1 Working as a Physicist",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "1.0 Paper 1",
        "open": false,
        "children": [
          {
            "name": "1.1 Mechanics",
            "open": false,
            "children": []
          },
          {
            "name": "1.2 Electric Circuits",
            "open": false,
            "children": []
          },
          {
            "name": "1.3 Further Mechanics",
            "open": false,
            "children": []
          },
          {
            "name": "1.4 Electric and Magnetic Fields",
            "open": false,
            "children": []
          },
          {
            "name": "1.5 Nuclear and Particle Physics",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "2.0 Paper 2",
        "open": false,
        "children": [
          {
            "name": "2.1 Materials",
            "open": false,
            "children": []
          },
          {
            "name": "2.2 Waves and the Particle Nature of Light",
            "open": false,
            "children": []
          },
          {
            "name": "2.3 Thermodynamics",
            "open": false,
            "children": []
          },
          {
            "name": "2.4 Space",
            "open": false,
            "children": []
          },
          {
            "name": "2.5 Nuclear Radiation",
            "open": false,
            "children": []
          },
          {
            "name": "2.6 Gravitational Fields",
            "open": false,
            "children": []
          },
          {
            "name": "2.7 Oscillations",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "3.0 Paper 3",
        "open": false,
        "children": [
          {
            "name": "Practical Skills",
            "open": false,
            "children": [
              {
                "name": "Core Practicals",
                "open": false,
                "children": [
                  {
                    "name": "CP01 Determine the Acceleration of a Freely-Falling Object",
                    "open": false,
                    "children": []
                  },
                  {
                    "name": "CP02 Determine the Electrical Resistivity of a Material",
                    "open": false,
                    "children": []
                  },
                  {
                    "name": "CP03 Determine the EMF and Internal Resistance of an Electrical Cell",
                    "open": false,
                    "children": []
                  },
                  {
                    "name": "CP04 Determine the Viscosity of a Liquid",
                    "open": false,
                    "children": []
                  },
                  {
                    "name": "CP05 Determine the Young’s Modulus of a Material",
                    "open": false,
                    "children": []
                  },
                  {
                    "name": "CP06 Determine the Speed of Sound in Air",
                    "open": false,
                    "children": []
                  },
                  {
                    "name": "CP07 Factors affecting the Frequency of a Vibrating String",
                    "open": false,
                    "children": []
                  },
                  {
                    "name": "CP08 Determine the Wavelength of Monochromatic Light",
                    "open": false,
                    "children": []
                  },
                  {
                    "name": "CP09 Investigate the Change in Momentum during a Collision",
                    "open": false,
                    "children": []
                  },
                  {
                    "name": "CP10 Use ICT to analyse Collisions between Small Spheres",
                    "open": false,
                    "children": []
                  },
                  {
                    "name": "CP11 Analyse the PD across a charging and discharging Capacitor",
                    "open": false,
                    "children": []
                  },
                  {
                    "name": "CP12 Calibrate a Thermistor in a Potential Divider circuit as a Thermostat",
                    "open": false,
                    "children": []
                  },
                  {
                    "name": "CP13 Determine the Specific Latent Heat of a Phase Change",
                    "open": false,
                    "children": []
                  },
                  {
                    "name": "CP14 Investigate the relationship between Pressure and Volume of a Gas",
                    "open": false,
                    "children": []
                  },
                  {
                    "name": "CP15 Investigate the Absorption of Gamma Radiation by Lead",
                    "open": false,
                    "children": []
                  },
                  {
                    "name": "CP16 Determine the value of an unknown mass using the Resonant Frequencies of the Oscillation of known masses",
                    "open": false,
                    "children": []
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "deckCount": 36
  },
  "Pearson Edexcel A-Level Biology A (9BN0)": {
    "root": "Pearson Edexcel A-Level Biology A (9BN0)",
    "open": true,
    "papers": [
      {
        "name": "Topic 1 - Lifestyle, Health and Risk",
        "open": false,
        "children": [
          {
            "name": "01 Circulation, Diffusion and Water",
            "open": false,
            "children": []
          },
          {
            "name": "02 Blood Vessels",
            "open": false,
            "children": []
          },
          {
            "name": "03 Heart Structure and the Cardiac Cycle",
            "open": false,
            "children": []
          },
          {
            "name": "04 Atherosclerosis, Clotting and CVD Risk",
            "open": false,
            "children": []
          },
          {
            "name": "05 Energy Budgets, Obesity and Risk Reduction",
            "open": false,
            "children": []
          },
          {
            "name": "06 Carbohydrates and Glycosidic Bonds",
            "open": false,
            "children": []
          },
          {
            "name": "07 Lipids, Cholesterol and CVD Treatments",
            "open": false,
            "children": []
          },
          {
            "name": "08 Core Practicals 1-2 and Invertebrate Ethics",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "Topic 2 - Genes and Health",
        "open": false,
        "children": [
          {
            "name": "01 Gas Exchange and Fick's Law",
            "open": false,
            "children": []
          },
          {
            "name": "02 Cell Membranes and Transport",
            "open": false,
            "children": []
          },
          {
            "name": "03 Nucleotides and DNA-RNA Structure",
            "open": false,
            "children": []
          },
          {
            "name": "04 Protein Synthesis and the Genetic Code",
            "open": false,
            "children": []
          },
          {
            "name": "05 Protein Structure, Haemoglobin and Collagen",
            "open": false,
            "children": []
          },
          {
            "name": "06 Enzymes and Initial Rates",
            "open": false,
            "children": []
          },
          {
            "name": "07 DNA Replication, Mutations and Cystic Fibrosis",
            "open": false,
            "children": []
          },
          {
            "name": "08 Inheritance, Cystic Fibrosis and Genetic Screening",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "Topic 3 - Voice of the Genome",
        "open": false,
        "children": [
          {
            "name": "01 Eukaryotic and Prokaryotic Cell Ultrastructure",
            "open": false,
            "children": []
          },
          {
            "name": "02 Mammalian Gametes and Fertilisation",
            "open": false,
            "children": []
          },
          {
            "name": "03 Genes, Linkage, Sex Linkage and Meiosis",
            "open": false,
            "children": []
          },
          {
            "name": "04 Cell Cycle, Mitosis and Root Tip Squashes",
            "open": false,
            "children": []
          },
          {
            "name": "05 Stem Cells and Medical Ethics",
            "open": false,
            "children": []
          },
          {
            "name": "06 Differentiation, Gene Expression and the Lac Operon",
            "open": false,
            "children": []
          },
          {
            "name": "07 Epigenetics, Genotype-Environment Interaction and Variation",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "Topic 4 - Biodiversity and Natural Resources",
        "open": false,
        "children": [
          {
            "name": "01 Biodiversity, Endemism and Diversity Indices",
            "open": false,
            "children": []
          },
          {
            "name": "02 Niches, Adaptation and Natural Selection",
            "open": false,
            "children": []
          },
          {
            "name": "03 Hardy-Weinberg, Isolation and Speciation",
            "open": false,
            "children": []
          },
          {
            "name": "04 Classification, Three Domains and Molecular Phylogeny",
            "open": false,
            "children": []
          },
          {
            "name": "05 Plant Cell Ultrastructure and EM Recognition",
            "open": false,
            "children": []
          },
          {
            "name": "06 Starch, Cellulose, Plant Fibres and Stem Tissues",
            "open": false,
            "children": []
          },
          {
            "name": "07 Plant Mineral Nutrition",
            "open": false,
            "children": []
          },
          {
            "name": "08 Drug Testing, Plant Antimicrobials and Conservation",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "Topic 5 - On the Wild Side",
        "open": false,
        "children": [
          {
            "name": "01 Ecosystems, Niches, Succession and Field Ecology",
            "open": false,
            "children": []
          },
          {
            "name": "02 ATP and Photosynthesis Overview",
            "open": false,
            "children": []
          },
          {
            "name": "03 Light-Dependent Reactions and the Hill Reaction",
            "open": false,
            "children": []
          },
          {
            "name": "04 Calvin Cycle, Chloroplasts and Photosynthetic Products",
            "open": false,
            "children": []
          },
          {
            "name": "05 Productivity, Trophic Transfer and Calculations",
            "open": false,
            "children": []
          },
          {
            "name": "06 Climate Evidence, the Greenhouse Effect and Models",
            "open": false,
            "children": []
          },
          {
            "name": "07 Temperature, Enzymes and Organism Development",
            "open": false,
            "children": []
          },
          {
            "name": "08 Evolution Evidence, Speciation and Climate Solutions",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "Topic 6 - Immunity, Infection and Forensics",
        "open": false,
        "children": [
          {
            "name": "01 Time of Death, Decomposition and Carbon Recycling",
            "open": false,
            "children": []
          },
          {
            "name": "02 DNA Profiling, PCR and Gel Electrophoresis",
            "open": false,
            "children": []
          },
          {
            "name": "03 Bacteria, Viruses, Tuberculosis and HIV",
            "open": false,
            "children": []
          },
          {
            "name": "04 Non-Specific Defences and Physical Barriers",
            "open": false,
            "children": []
          },
          {
            "name": "05 Antigens, Antibodies, B Cells and T Cells",
            "open": false,
            "children": []
          },
          {
            "name": "06 Post-Transcriptional Modification and Types of Immunity",
            "open": false,
            "children": []
          },
          {
            "name": "07 Pathogen Evasion, Antibiotics and Infection Control",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "Topic 7 - Run for your Life",
        "open": false,
        "children": [
          {
            "name": "01 Movement, Muscle Fibres and Sliding Filaments",
            "open": false,
            "children": []
          },
          {
            "name": "02 Respiration Overview, Glycolysis and Lactate",
            "open": false,
            "children": []
          },
          {
            "name": "03 Link Reaction, Krebs Cycle and Oxidative Phosphorylation",
            "open": false,
            "children": []
          },
          {
            "name": "04 Core Practical 16 - Rate of Respiration",
            "open": false,
            "children": []
          },
          {
            "name": "05 Cardiac Electrical Activity, ECGs and Cardiac Output",
            "open": false,
            "children": []
          },
          {
            "name": "06 Exercise, Spirometry and Core Practical 17",
            "open": false,
            "children": []
          },
          {
            "name": "07 Homeostasis, Thermoregulation, Exercise Ethics and Technology",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "Topic 8 - Grey Matter",
        "open": false,
        "children": [
          {
            "name": "01 Neurones, Stimulus-Response and the Pupil Reflex",
            "open": false,
            "children": []
          },
          {
            "name": "02 Action Potentials and Saltatory Conduction",
            "open": false,
            "children": []
          },
          {
            "name": "03 Synapses, Acetylcholine and Drugs",
            "open": false,
            "children": []
          },
          {
            "name": "04 Rod Cells and Detection of Light",
            "open": false,
            "children": []
          },
          {
            "name": "05 Plant Responses - Phytochrome and IAA",
            "open": false,
            "children": []
          },
          {
            "name": "06 Coordination, Brain Regions and Medical Imaging",
            "open": false,
            "children": []
          },
          {
            "name": "07 Visual Development, Animal Models, Habituation and Nature-Nurture",
            "open": false,
            "children": []
          },
          {
            "name": "08 Personalised Medicine and GM Drug Production",
            "open": false,
            "children": []
          }
        ]
      }
    ],
    "deckCount": 70
  },
  "Pearson Edexcel GCSE Biology 1BI0": {
    "root": "Pearson Edexcel GCSE Biology 1BI0",
    "open": true,
    "papers": [
      {
        "name": "01 Paper 1",
        "open": false,
        "children": [
          {
            "name": "01 Key concepts in biology",
            "open": false,
            "children": [
              {
                "name": "01 Cells and specialised cells",
                "open": false,
                "children": []
              },
              {
                "name": "02 Microscopy scale and scientific drawings",
                "open": false,
                "children": []
              },
              {
                "name": "03 Enzymes and biological catalysts",
                "open": false,
                "children": []
              },
              {
                "name": "04 Food tests and calorimetry",
                "open": false,
                "children": []
              },
              {
                "name": "05 Cell transport and osmosis",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "02 Cells and control",
            "open": false,
            "children": [
              {
                "name": "01 Cell cycle mitosis and growth",
                "open": false,
                "children": []
              },
              {
                "name": "02 Stem cells and meristems",
                "open": false,
                "children": []
              },
              {
                "name": "03 Brain investigation and treatment",
                "open": false,
                "children": []
              },
              {
                "name": "04 Neurones synapses and reflexes",
                "open": false,
                "children": []
              },
              {
                "name": "05 The eye and correction of defects",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "03 Genetics",
            "open": false,
            "children": [
              {
                "name": "01 Reproduction and meiosis",
                "open": false,
                "children": []
              },
              {
                "name": "02 DNA genome and protein synthesis",
                "open": false,
                "children": []
              },
              {
                "name": "03 Mendel and genetic terminology",
                "open": false,
                "children": []
              },
              {
                "name": "04 Genetic crosses pedigrees and inheritance",
                "open": false,
                "children": []
              },
              {
                "name": "05 Variation mutations and the Human Genome Project",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "04 Natural selection and genetic modification",
            "open": false,
            "children": [
              {
                "name": "01 Darwin Wallace natural selection and resistance",
                "open": false,
                "children": []
              },
              {
                "name": "02 Human evolution fossils and stone tools",
                "open": false,
                "children": []
              },
              {
                "name": "03 Evolutionary evidence and classification",
                "open": false,
                "children": []
              },
              {
                "name": "04 Selective breeding and tissue culture",
                "open": false,
                "children": []
              },
              {
                "name": "05 Genetic engineering agriculture and ethics",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "05 Health, disease and the development of medicines",
            "open": false,
            "children": [
              {
                "name": "01 Health disease and pathogens",
                "open": false,
                "children": []
              },
              {
                "name": "02 Infections transmission viruses and STIs",
                "open": false,
                "children": []
              },
              {
                "name": "03 Plant defences and disease detection",
                "open": false,
                "children": []
              },
              {
                "name": "04 Human defences immunity and antibiotics",
                "open": false,
                "children": []
              },
              {
                "name": "05 Culturing microorganisms and antimicrobial testing",
                "open": false,
                "children": []
              },
              {
                "name": "06 Developing medicines",
                "open": false,
                "children": []
              },
              {
                "name": "07 Monoclonal antibodies",
                "open": false,
                "children": []
              },
              {
                "name": "08 Non-communicable disease and cardiovascular treatment",
                "open": false,
                "children": []
              }
            ]
          }
        ]
      },
      {
        "name": "02 Paper 2",
        "open": false,
        "children": [
          {
            "name": "06 Plant structures and their functions",
            "open": false,
            "children": [
              {
                "name": "01 Photosynthesis limiting factors and core practical",
                "open": false,
                "children": []
              },
              {
                "name": "02 Root hair xylem phloem and transport",
                "open": false,
                "children": []
              },
              {
                "name": "03 Leaf structure transpiration and plant adaptations",
                "open": false,
                "children": []
              },
              {
                "name": "04 Plant hormones and commercial uses",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "07 Animal coordination, control and homeostasis",
            "open": false,
            "children": [
              {
                "name": "01 Endocrine glands adrenalin and thyroxine",
                "open": false,
                "children": []
              },
              {
                "name": "02 Menstrual cycle contraception and fertility",
                "open": false,
                "children": []
              },
              {
                "name": "03 Homeostasis and thermoregulation",
                "open": false,
                "children": []
              },
              {
                "name": "04 Blood glucose diabetes and health data",
                "open": false,
                "children": []
              },
              {
                "name": "05 Kidney osmoregulation and urea",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "08 Exchange and transport in animals",
            "open": false,
            "children": [
              {
                "name": "01 Exchange surfaces diffusion and Fick's law",
                "open": false,
                "children": []
              },
              {
                "name": "02 Blood vessels heart and circulation",
                "open": false,
                "children": []
              },
              {
                "name": "03 Respiration core practical and cardiac output",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "09 Ecosystems and material cycles",
            "open": false,
            "children": [
              {
                "name": "01 Ecosystems interactions and interdependence",
                "open": false,
                "children": []
              },
              {
                "name": "02 Fieldwork quadrats transects and sampling",
                "open": false,
                "children": []
              },
              {
                "name": "03 Trophic levels biomass and energy transfer",
                "open": false,
                "children": []
              },
              {
                "name": "04 Human impacts biodiversity and food security",
                "open": false,
                "children": []
              },
              {
                "name": "05 Carbon water and nitrogen cycles",
                "open": false,
                "children": []
              },
              {
                "name": "06 Indicator species decomposition and composting",
                "open": false,
                "children": []
              }
            ]
          }
        ]
      }
    ],
    "deckCount": 58
  },
  "Pearson Edexcel International A Level Chemistry": {
    "root": "Pearson Edexcel International A Level Chemistry",
    "open": true,
    "papers": [
      {
        "name": "WCH11",
        "open": false,
        "children": [
          {
            "name": "01 Formulae, Equations and Amount of Substance",
            "open": false,
            "children": []
          },
          {
            "name": "02 Atomic Structure and the Periodic Table",
            "open": false,
            "children": []
          },
          {
            "name": "03 Bonding and Structure",
            "open": false,
            "children": []
          },
          {
            "name": "04 Introductory Organic Chemistry and Alkanes",
            "open": false,
            "children": []
          },
          {
            "name": "05 Alkenes",
            "open": false,
            "children": []
          },
          {
            "name": "06 Unit 1 Synoptic Calculations, Data and Experimental Methods",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "WCH12",
        "open": false,
        "children": [
          {
            "name": "01 Energetics",
            "open": false,
            "children": []
          },
          {
            "name": "02 Intermolecular Forces",
            "open": false,
            "children": []
          },
          {
            "name": "03 Redox Chemistry and Groups 1, 2 and 7",
            "open": false,
            "children": []
          },
          {
            "name": "04 Introduction to Kinetics and Equilibria",
            "open": false,
            "children": []
          },
          {
            "name": "05 Halogenoalkanes",
            "open": false,
            "children": []
          },
          {
            "name": "06 Alcohols and Organic Preparation Techniques",
            "open": false,
            "children": []
          },
          {
            "name": "07 Mass Spectrometry and Infrared Spectroscopy",
            "open": false,
            "children": []
          },
          {
            "name": "08 Unit 2 Contemporary Context, Synoptic and Data-Booklet Skills",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "WCH13",
        "open": false,
        "children": [
          {
            "name": "01 Measurements, Recording, Significant Figures and Uncertainty",
            "open": false,
            "children": []
          },
          {
            "name": "02 Core Practical 1 - Molar Volume of a Gas",
            "open": false,
            "children": []
          },
          {
            "name": "03 Core Practical 2 - Hess's Law Enthalpy Determination",
            "open": false,
            "children": []
          },
          {
            "name": "04 Core Practicals 3 and 4 - Volumetric Analysis",
            "open": false,
            "children": []
          },
          {
            "name": "05 Core Practical 5 - Halogenoalkane Hydrolysis Rates",
            "open": false,
            "children": []
          },
          {
            "name": "06 Core Practical 6 - Chlorination of 2-Methylpropan-2-ol",
            "open": false,
            "children": []
          },
          {
            "name": "07 Core Practical 7 - Oxidation of Propan-1-ol",
            "open": false,
            "children": []
          },
          {
            "name": "08 Core Practical 8 - Inorganic and Organic Unknowns",
            "open": false,
            "children": []
          },
          {
            "name": "09 Planning, Variables, Risk and Method Evaluation",
            "open": false,
            "children": []
          },
          {
            "name": "10 Tables, Graphs, Calculations and Unfamiliar Practical Applications",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "WCH14",
        "open": false,
        "children": [
          {
            "name": "01 Kinetics and Rate Equations",
            "open": false,
            "children": []
          },
          {
            "name": "02 Entropy and Energetics",
            "open": false,
            "children": []
          },
          {
            "name": "03 Chemical Equilibria",
            "open": false,
            "children": []
          },
          {
            "name": "04 Acid-Base Equilibria",
            "open": false,
            "children": []
          },
          {
            "name": "05 Chirality and Optical Isomerism",
            "open": false,
            "children": []
          },
          {
            "name": "06 Carbonyl Compounds",
            "open": false,
            "children": []
          },
          {
            "name": "07 Carboxylic Acids and Derivatives",
            "open": false,
            "children": []
          },
          {
            "name": "08 Spectroscopy and Chromatography",
            "open": false,
            "children": []
          },
          {
            "name": "09 Unit 4 Data, Calculation and Synoptic Skills",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "WCH15",
        "open": false,
        "children": [
          {
            "name": "01 Redox Equilibria and Electrochemical Cells",
            "open": false,
            "children": []
          },
          {
            "name": "02 Transition-Metal Electronic Structure and Complexes",
            "open": false,
            "children": []
          },
          {
            "name": "03 Transition-Metal Reactions, Colours and Catalysis",
            "open": false,
            "children": []
          },
          {
            "name": "04 Arenes and Electrophilic Substitution",
            "open": false,
            "children": []
          },
          {
            "name": "05 Amines and Amides",
            "open": false,
            "children": []
          },
          {
            "name": "06 Amino Acids, Proteins, Polyamides and Addition Polymers",
            "open": false,
            "children": []
          },
          {
            "name": "07 Organic Synthesis, Carbon-Chain Extension and Multi-Step Routes",
            "open": false,
            "children": []
          },
          {
            "name": "08 Structural Deduction from Combined Analytical Evidence",
            "open": false,
            "children": []
          },
          {
            "name": "09 Unit 5 Contemporary Context, Synoptic and Data-Booklet Skills",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "WCH16",
        "open": false,
        "children": [
          {
            "name": "01 Advanced Measurement, Uncertainty, Risk and Experimental Design",
            "open": false,
            "children": []
          },
          {
            "name": "02 Core Practicals 9a and 9b - Iodine-Propanone and Clock Kinetics",
            "open": false,
            "children": []
          },
          {
            "name": "03 Core Practical 10 - Activation Energy",
            "open": false,
            "children": []
          },
          {
            "name": "04 Core Practical 11 - Ka of a Weak Acid",
            "open": false,
            "children": []
          },
          {
            "name": "05 Core Practical 12 - Electrochemical Cells",
            "open": false,
            "children": []
          },
          {
            "name": "06 Core Practicals 13a and 13b - Redox Titrations",
            "open": false,
            "children": []
          },
          {
            "name": "07 Core Practical 14 - Preparation of a Transition-Metal Complex",
            "open": false,
            "children": []
          },
          {
            "name": "08 Core Practical 15 - Inorganic and Organic Unknowns",
            "open": false,
            "children": []
          },
          {
            "name": "09 Core Practical 16 - Preparation of Aspirin",
            "open": false,
            "children": []
          },
          {
            "name": "10 Advanced Preparation, Purification and Analytical Techniques",
            "open": false,
            "children": []
          },
          {
            "name": "11 Tables, Graphs, Calculations and Unfamiliar Practical Applications",
            "open": false,
            "children": []
          }
        ]
      }
    ],
    "deckCount": 60
  },
  "Pearson Edexcel International A Level Physics (WPH11-WPH16)": {
    "root": "Pearson Edexcel International A Level Physics (WPH11-WPH16)",
    "open": true,
    "papers": [
      {
        "name": "01 - Unit 1: Mechanics and Materials [WPH11]",
        "open": false,
        "children": [
          {
            "name": "01 - Mechanics",
            "open": false,
            "children": []
          },
          {
            "name": "02 - Materials",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "02 - Unit 2: Waves and Electricity [WPH12]",
        "open": false,
        "children": [
          {
            "name": "01 - Waves",
            "open": false,
            "children": []
          },
          {
            "name": "02 - Quantum Physics",
            "open": false,
            "children": []
          },
          {
            "name": "03 - Electric Circuits",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "03 - Unit 3: Practical Skills in Physics I [WPH13]",
        "open": false,
        "children": [
          {
            "name": "01 - Planning Experiments",
            "open": false,
            "children": []
          },
          {
            "name": "02 - Apparatus and Measurements",
            "open": false,
            "children": []
          },
          {
            "name": "03 - Variables and Experimental Methods",
            "open": false,
            "children": []
          },
          {
            "name": "04 - Uncertainties and Errors",
            "open": false,
            "children": []
          },
          {
            "name": "05 - Data Tables and Processing",
            "open": false,
            "children": []
          },
          {
            "name": "06 - Graphs and Analysis",
            "open": false,
            "children": []
          },
          {
            "name": "07 - Conclusions and Evaluation",
            "open": false,
            "children": []
          },
          {
            "name": "08 - Unit 1 Core Practicals",
            "open": false,
            "children": []
          },
          {
            "name": "09 - Unit 2 Core Practicals",
            "open": false,
            "children": []
          },
          {
            "name": "10 - Unfamiliar Practical Investigations",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "04 - Unit 4: Further Mechanics, Fields and Particles [WPH14]",
        "open": false,
        "children": [
          {
            "name": "01 - Momentum and Impulse",
            "open": false,
            "children": []
          },
          {
            "name": "02 - Circular Motion",
            "open": false,
            "children": []
          },
          {
            "name": "03 - Electric Fields",
            "open": false,
            "children": []
          },
          {
            "name": "04 - Capacitors",
            "open": false,
            "children": []
          },
          {
            "name": "05 - Magnetic Fields",
            "open": false,
            "children": []
          },
          {
            "name": "06 - Electromagnetic Induction",
            "open": false,
            "children": []
          },
          {
            "name": "07 - Atomic Structure",
            "open": false,
            "children": []
          },
          {
            "name": "08 - Particle Accelerators and Detectors",
            "open": false,
            "children": []
          },
          {
            "name": "09 - Particle Physics",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "05 - Unit 5: Thermodynamics, Radiation, Oscillations and Cosmology [WPH15]",
        "open": false,
        "children": [
          {
            "name": "01 - Thermal Physics",
            "open": false,
            "children": []
          },
          {
            "name": "02 - Ideal Gases and Kinetic Theory",
            "open": false,
            "children": []
          },
          {
            "name": "03 - Nuclear Binding Energy",
            "open": false,
            "children": []
          },
          {
            "name": "04 - Radioactive Decay",
            "open": false,
            "children": []
          },
          {
            "name": "05 - Simple Harmonic Motion",
            "open": false,
            "children": []
          },
          {
            "name": "06 - Damping and Resonance",
            "open": false,
            "children": []
          },
          {
            "name": "07 - Gravitational Fields",
            "open": false,
            "children": []
          },
          {
            "name": "08 - Stars",
            "open": false,
            "children": []
          },
          {
            "name": "09 - Cosmology",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "06 - Unit 6: Practical Skills in Physics II [WPH16]",
        "open": false,
        "children": [
          {
            "name": "01 - Advanced Experimental Planning",
            "open": false,
            "children": []
          },
          {
            "name": "02 - Apparatus Selection and Measurements",
            "open": false,
            "children": []
          },
          {
            "name": "03 - Variables and Experimental Methods",
            "open": false,
            "children": []
          },
          {
            "name": "04 - Uncertainties and Error Analysis",
            "open": false,
            "children": []
          },
          {
            "name": "05 - Data Processing and Linearisation",
            "open": false,
            "children": []
          },
          {
            "name": "06 - Graphs and Advanced Analysis",
            "open": false,
            "children": []
          },
          {
            "name": "07 - Conclusions, Evaluation and Improvements",
            "open": false,
            "children": []
          },
          {
            "name": "08 - Unit 4 Core Practicals",
            "open": false,
            "children": []
          },
          {
            "name": "09 - Unit 5 Core Practicals",
            "open": false,
            "children": []
          },
          {
            "name": "10 - Synoptic and Unfamiliar Investigations",
            "open": false,
            "children": []
          }
        ]
      }
    ],
    "deckCount": 50
  },
  "Pearson Edexcel International GCSE Biology 4BI1": {
    "root": "Pearson Edexcel International GCSE Biology 4BI1",
    "open": true,
    "papers": [
      {
        "name": "01 The nature and variety of living organisms",
        "open": false,
        "children": [
          {
            "name": "01 Characteristics of living organisms",
            "open": false,
            "children": []
          },
          {
            "name": "02 Eukaryotic organisms",
            "open": false,
            "children": []
          },
          {
            "name": "03 Prokaryotes pathogens and viruses",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "02 Structures and functions in living organisms",
        "open": false,
        "children": [
          {
            "name": "01 Levels of organisation",
            "open": false,
            "children": []
          },
          {
            "name": "02 Cell structure differentiation and stem cells",
            "open": false,
            "children": []
          },
          {
            "name": "03 Biological molecules food tests and enzymes",
            "open": false,
            "children": []
          },
          {
            "name": "04 Diffusion osmosis and active transport",
            "open": false,
            "children": []
          },
          {
            "name": "05 Plant nutrition and photosynthesis",
            "open": false,
            "children": []
          },
          {
            "name": "06 Human nutrition digestion and food energy",
            "open": false,
            "children": []
          },
          {
            "name": "07 Respiration and ATP",
            "open": false,
            "children": []
          },
          {
            "name": "08 Gas exchange in flowering plants",
            "open": false,
            "children": []
          },
          {
            "name": "09 Gas exchange ventilation and smoking in humans",
            "open": false,
            "children": []
          },
          {
            "name": "10 Transport principles",
            "open": false,
            "children": []
          },
          {
            "name": "11 Transport in flowering plants",
            "open": false,
            "children": []
          },
          {
            "name": "12 Blood heart and circulation",
            "open": false,
            "children": []
          },
          {
            "name": "13 Excretion in flowering plants",
            "open": false,
            "children": []
          },
          {
            "name": "14 Human excretion kidney and osmoregulation",
            "open": false,
            "children": []
          },
          {
            "name": "15 Co-ordination response and homeostasis",
            "open": false,
            "children": []
          },
          {
            "name": "16 Plant responses and auxin",
            "open": false,
            "children": []
          },
          {
            "name": "17 Human nervous hormonal and temperature control",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "03 Reproduction and inheritance",
        "open": false,
        "children": [
          {
            "name": "01 Sexual and asexual reproduction",
            "open": false,
            "children": []
          },
          {
            "name": "02 Reproduction in flowering plants",
            "open": false,
            "children": []
          },
          {
            "name": "03 Human reproduction and development",
            "open": false,
            "children": []
          },
          {
            "name": "04 DNA RNA and protein synthesis",
            "open": false,
            "children": []
          },
          {
            "name": "05 Alleles genetic crosses pedigrees and sex determination",
            "open": false,
            "children": []
          },
          {
            "name": "06 Mitosis meiosis and chromosome number",
            "open": false,
            "children": []
          },
          {
            "name": "07 Variation mutation and mutagens",
            "open": false,
            "children": []
          },
          {
            "name": "08 Natural selection and antibiotic resistance",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "04 Ecology and the environment",
        "open": false,
        "children": [
          {
            "name": "01 Ecosystems populations biodiversity and sampling",
            "open": false,
            "children": []
          },
          {
            "name": "02 Feeding relationships and energy transfer",
            "open": false,
            "children": []
          },
          {
            "name": "03 Carbon and nitrogen cycles",
            "open": false,
            "children": []
          },
          {
            "name": "04 Pollution greenhouse effect eutrophication and deforestation",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "05 Use of biological resources",
        "open": false,
        "children": [
          {
            "name": "01 Crop yield fertilisers and pest control",
            "open": false,
            "children": []
          },
          {
            "name": "02 Yeast yoghurt and industrial fermentation",
            "open": false,
            "children": []
          },
          {
            "name": "03 Fish farming",
            "open": false,
            "children": []
          },
          {
            "name": "04 Selective breeding",
            "open": false,
            "children": []
          },
          {
            "name": "05 Genetic modification and recombinant DNA",
            "open": false,
            "children": []
          },
          {
            "name": "06 Micropropagation and animal cloning",
            "open": false,
            "children": []
          }
        ]
      }
    ],
    "deckCount": 44
  },
  "Pearson Edexcel International GCSE Chemistry (4CH1)": {
    "root": "Pearson Edexcel International GCSE Chemistry (4CH1)",
    "open": true,
    "papers": [
      {
        "name": "01 Principles of chemistry",
        "open": false,
        "children": [
          {
            "name": "01 States of matter",
            "open": false,
            "children": []
          },
          {
            "name": "02 Elements, compounds and mixtures",
            "open": false,
            "children": []
          },
          {
            "name": "03 Atomic structure",
            "open": false,
            "children": []
          },
          {
            "name": "04 The Periodic Table",
            "open": false,
            "children": []
          },
          {
            "name": "05 Chemical formulae, equations and calculations",
            "open": false,
            "children": []
          },
          {
            "name": "06 Ionic bonding",
            "open": false,
            "children": []
          },
          {
            "name": "07 Covalent bonding",
            "open": false,
            "children": []
          },
          {
            "name": "08 Metallic bonding",
            "open": false,
            "children": []
          },
          {
            "name": "09 Electrolysis",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "02 Inorganic chemistry",
        "open": false,
        "children": [
          {
            "name": "01 Group 1 - lithium, sodium and potassium",
            "open": false,
            "children": []
          },
          {
            "name": "02 Group 7 - chlorine, bromine and iodine",
            "open": false,
            "children": []
          },
          {
            "name": "03 Gases in the atmosphere",
            "open": false,
            "children": []
          },
          {
            "name": "04 Reactivity series",
            "open": false,
            "children": []
          },
          {
            "name": "05 Extraction and uses of metals",
            "open": false,
            "children": []
          },
          {
            "name": "06 Acids, alkalis and titrations",
            "open": false,
            "children": []
          },
          {
            "name": "07 Acids, bases and salt preparations",
            "open": false,
            "children": []
          },
          {
            "name": "08 Chemical tests",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "03 Physical chemistry",
        "open": false,
        "children": [
          {
            "name": "01 Energetics",
            "open": false,
            "children": []
          },
          {
            "name": "02 Rates of reaction",
            "open": false,
            "children": []
          },
          {
            "name": "03 Reversible reactions and equilibria",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "04 Organic chemistry",
        "open": false,
        "children": [
          {
            "name": "01 Introduction to organic chemistry",
            "open": false,
            "children": []
          },
          {
            "name": "02 Crude oil",
            "open": false,
            "children": []
          },
          {
            "name": "03 Alkanes",
            "open": false,
            "children": []
          },
          {
            "name": "04 Alkenes",
            "open": false,
            "children": []
          },
          {
            "name": "05 Alcohols",
            "open": false,
            "children": []
          },
          {
            "name": "06 Carboxylic acids",
            "open": false,
            "children": []
          },
          {
            "name": "07 Esters",
            "open": false,
            "children": []
          },
          {
            "name": "08 Synthetic polymers",
            "open": false,
            "children": []
          }
        ]
      }
    ],
    "deckCount": 33
  },
  "WJEC AS-A Level Biology": {
    "root": "WJEC AS-A Level Biology",
    "open": true,
    "papers": [
      {
        "name": "01 AS Unit 1 - Basic Biochemistry and Cell Organisation",
        "open": false,
        "children": [
          {
            "name": "01 Chemical elements are joined together to form biological compounds",
            "open": false,
            "children": []
          },
          {
            "name": "02 Cell structure and organisation",
            "open": false,
            "children": []
          },
          {
            "name": "03 Cell membranes and transport",
            "open": false,
            "children": []
          },
          {
            "name": "04 Biological reactions are regulated by enzymes",
            "open": false,
            "children": []
          },
          {
            "name": "05 Nucleic acids and their functions",
            "open": false,
            "children": []
          },
          {
            "name": "06 Genetic information is copied and passed on to daughter cells",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "02 AS Unit 2 - Biodiversity and Physiology of Body Systems",
        "open": false,
        "children": [
          {
            "name": "01 All organisms are related through their evolutionary history",
            "open": false,
            "children": []
          },
          {
            "name": "02 Adaptations for gas exchange",
            "open": false,
            "children": []
          },
          {
            "name": "03 Adaptations for transport",
            "open": false,
            "children": []
          },
          {
            "name": "04 Adaptations for nutrition",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "03 A2 Unit 3 - Energy, Homeostasis and the Environment",
        "open": false,
        "children": [
          {
            "name": "01 Importance of ATP",
            "open": false,
            "children": []
          },
          {
            "name": "02 Photosynthesis uses light energy to synthesise organic molecules",
            "open": false,
            "children": []
          },
          {
            "name": "03 Respiration releases chemical energy in biological processes",
            "open": false,
            "children": []
          },
          {
            "name": "04 Microbiology",
            "open": false,
            "children": []
          },
          {
            "name": "05 Population size and ecosystems",
            "open": false,
            "children": []
          },
          {
            "name": "06 Human impact on the environment",
            "open": false,
            "children": []
          },
          {
            "name": "07 Homeostasis and the kidney",
            "open": false,
            "children": []
          },
          {
            "name": "08 The nervous system",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "04 A2 Unit 4 - Variation, Inheritance and Options",
        "open": false,
        "children": [
          {
            "name": "01 Sexual reproduction in humans",
            "open": false,
            "children": []
          },
          {
            "name": "02 Sexual reproduction in plants",
            "open": false,
            "children": []
          },
          {
            "name": "03 Inheritance",
            "open": false,
            "children": []
          },
          {
            "name": "04 Variation and evolution",
            "open": false,
            "children": []
          },
          {
            "name": "05 Application of reproduction and genetics",
            "open": false,
            "children": []
          },
          {
            "name": "06 Option A - Immunology and Disease",
            "open": false,
            "children": [
              {
                "name": "01 Disease",
                "open": false,
                "children": []
              },
              {
                "name": "02 Antibiotics",
                "open": false,
                "children": []
              },
              {
                "name": "03 Immune response",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "07 Option B - Human Musculoskeletal Anatomy",
            "open": false,
            "children": [
              {
                "name": "01 Skeletal tissues",
                "open": false,
                "children": []
              },
              {
                "name": "02 Structure and function of human skeleton",
                "open": false,
                "children": []
              },
              {
                "name": "03 Joints",
                "open": false,
                "children": []
              }
            ]
          },
          {
            "name": "08 Option C - Neurobiology and Behaviour",
            "open": false,
            "children": [
              {
                "name": "01 The brain",
                "open": false,
                "children": []
              },
              {
                "name": "02 Neuroscience",
                "open": false,
                "children": []
              },
              {
                "name": "03 Behaviour",
                "open": false,
                "children": []
              }
            ]
          }
        ]
      },
      {
        "name": "05 A2 Unit 5 - Practical Examination",
        "open": false,
        "children": [
          {
            "name": "01 Experimental task and practical analysis task",
            "open": false,
            "children": []
          }
        ]
      }
    ],
    "deckCount": 42
  },
  "WJEC GCSE Chemistry 3410QS": {
    "root": "WJEC GCSE Chemistry 3410QS",
    "open": true,
    "papers": [
      {
        "name": "1. Unit 1 — Chemical Substances, Reactions and Essential Resources",
        "open": false,
        "children": [
          {
            "name": "1.1 The nature of substances and chemical reactions",
            "open": false,
            "children": []
          },
          {
            "name": "1.2 Atomic structure and the Periodic Table",
            "open": false,
            "children": []
          },
          {
            "name": "1.3 Water",
            "open": false,
            "children": []
          },
          {
            "name": "1.4 The ever-changing Earth",
            "open": false,
            "children": []
          },
          {
            "name": "1.5 Rate of chemical change",
            "open": false,
            "children": []
          },
          {
            "name": "1.6 Limestone",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "2. Unit 2 — Chemical Bonding, Application of Chemical Reactions and Organic Chemistry",
        "open": false,
        "children": [
          {
            "name": "2.1 Bonding, structure and properties",
            "open": false,
            "children": []
          },
          {
            "name": "2.2 Acids, bases and salts",
            "open": false,
            "children": []
          },
          {
            "name": "2.3 Metals and their extraction",
            "open": false,
            "children": []
          },
          {
            "name": "2.4 Chemical reactions and energy",
            "open": false,
            "children": []
          },
          {
            "name": "2.5 Crude oil, fuels and organic chemistry",
            "open": false,
            "children": []
          },
          {
            "name": "2.6 Reversible reactions, industrial processes and important chemicals",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "3. Unit 3 — Scientific Enquiry",
        "open": false,
        "children": [
          {
            "name": "3.1 SE1 Benefits and challenges of scientific enquiry",
            "open": false,
            "children": []
          },
          {
            "name": "3.2 SE2 Scientific models and influencing factors",
            "open": false,
            "children": []
          },
          {
            "name": "3.3 SE3 Informed decisions from scientific enquiry",
            "open": false,
            "children": []
          },
          {
            "name": "3.4 SE4 Designing a method of enquiry",
            "open": false,
            "children": []
          },
          {
            "name": "3.5 SE5 Primary data and data quality",
            "open": false,
            "children": []
          },
          {
            "name": "3.6 SE6 Secondary data and data quality",
            "open": false,
            "children": []
          },
          {
            "name": "3.7 SE7 Data analysis",
            "open": false,
            "children": []
          },
          {
            "name": "3.8 SE8 Conclusions and evaluation",
            "open": false,
            "children": []
          }
        ]
      }
    ],
    "deckCount": 24
  },
  "WJEC GCSE Physics 3420QS": {
    "root": "WJEC GCSE Physics 3420QS",
    "open": true,
    "papers": [
      {
        "name": "Unit 1 - Electricity, Energy and Waves",
        "open": false,
        "children": [
          {
            "name": "01 Electric circuits",
            "open": false,
            "children": []
          },
          {
            "name": "02 Generating electricity",
            "open": false,
            "children": []
          },
          {
            "name": "03 Making use of energy",
            "open": false,
            "children": []
          },
          {
            "name": "04 Domestic electricity",
            "open": false,
            "children": []
          },
          {
            "name": "05 Features of waves",
            "open": false,
            "children": []
          },
          {
            "name": "06 Total internal reflection",
            "open": false,
            "children": []
          },
          {
            "name": "07 Seismic waves",
            "open": false,
            "children": []
          },
          {
            "name": "08 Kinetic theory",
            "open": false,
            "children": []
          },
          {
            "name": "09 Electromagnetism",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "Unit 2 - Forces, Space and Radioactivity",
        "open": false,
        "children": [
          {
            "name": "01 Distance, speed and acceleration",
            "open": false,
            "children": []
          },
          {
            "name": "02 Newton's laws",
            "open": false,
            "children": []
          },
          {
            "name": "03 Work and energy",
            "open": false,
            "children": []
          },
          {
            "name": "04 Further motion concepts",
            "open": false,
            "children": []
          },
          {
            "name": "05 Stars and planets",
            "open": false,
            "children": []
          },
          {
            "name": "06 The Universe",
            "open": false,
            "children": []
          },
          {
            "name": "07 Types of radiation",
            "open": false,
            "children": []
          },
          {
            "name": "08 Half-life",
            "open": false,
            "children": []
          },
          {
            "name": "09 Nuclear decay and nuclear energy",
            "open": false,
            "children": []
          }
        ]
      },
      {
        "name": "Unit 3 - Scientific Enquiry",
        "open": false,
        "children": [
          {
            "name": "01 Planning, hypotheses and variables",
            "open": false,
            "children": []
          },
          {
            "name": "02 Apparatus, methods, safety and controls",
            "open": false,
            "children": []
          },
          {
            "name": "03 Tables, graphs and mathematical processing",
            "open": false,
            "children": []
          },
          {
            "name": "04 Analysis, conclusions and scientific reasoning",
            "open": false,
            "children": []
          },
          {
            "name": "05 Errors, uncertainty, evaluation and improvements",
            "open": false,
            "children": []
          }
        ]
      }
    ],
    "deckCount": 27
  }
};
